/* ==========================================================================
   Crown & Paw Complete Interactive Storefront & Customizer Engine
   100% Native Crown & Paw DOM, CSS Classes, and Shopify Architecture
   ========================================================================== */

(function() {
  'use strict';

  var DEFAULT_PORTRAIT_IMG = '//crownandpaw.com/cdn/shop/files/KuboTheGeneral_375x.webp?v=1776197193';

  function formatMoney(cents) {
    var n = (Number(cents) || 0) / 100;
    return '$' + n.toFixed(2);
  }

  function formatMoneyShort(cents) {
    var n = (Number(cents) || 0) / 100;
    return n % 1 === 0 ? '$' + n.toFixed(0) : '$' + n.toFixed(2);
  }

  function escapeHtml(str) {
    return String(str || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  var PRODUCT_HANDLE_ALIASES = {
    'step-brothers-custom-two-pet-canvas': 'the-step-brothers-custom-pet-canvas',
    'custom-pet-fleece-blanket': 'merchants-custom-pet-blanket',
    'custom-pet-portrait-mug': 'young-king-custom-pet-portrait-mug',
    'custom-pet-sweatshirt': 'custom-pet-portrait-sweatshirt',
    'custom-pet-hoodie': 'custom-pet-portrait-hoodie',
    'custom-pet-pillow': 'merchants-custom-pet-pillow'
  };

  function getCatalogProduct(handle) {
    var cat = window.CP_CATALOG;
    if (!cat || !cat.productsByHandle) return null;
    if (handle && cat.productsByHandle[handle]) return cat.productsByHandle[handle];
    if (handle && PRODUCT_HANDLE_ALIASES[handle] && cat.productsByHandle[PRODUCT_HANDLE_ALIASES[handle]]) {
      return cat.productsByHandle[PRODUCT_HANDLE_ALIASES[handle]];
    }
    var keys = Object.keys(cat.productsByHandle);
    for (var i = 0; i < keys.length; i++) {
      if (handle && (keys[i].indexOf(handle) !== -1 || handle.indexOf(keys[i]) !== -1)) {
        return cat.productsByHandle[keys[i]];
      }
    }
    if (handle) {
      var stopWords = { custom: 1, pet: 1, canvas: 1, portrait: 1, portraits: 1, the: 1, and: 1, one: 1, two: 1 };
      var tokens = handle.toLowerCase().split('-').filter(function(t) { return t && !stopWords[t]; });
      var bestKey = null;
      var bestScore = 0;
      for (var j = 0; j < keys.length; j++) {
        var kLower = keys[j].toLowerCase();
        var score = 0;
        for (var tIdx = 0; tIdx < tokens.length; tIdx++) {
          if (kLower.indexOf(tokens[tIdx]) !== -1) score++;
        }
        if (score > bestScore) {
          bestScore = score;
          bestKey = keys[j];
        }
      }
      if (bestKey && bestScore >= 1) {
        return cat.productsByHandle[bestKey];
      }
    }
    return cat.productsByHandle[cat.defaultProductHandle] || cat.productsByHandle[keys[0]];
  }

  function buildLooxStarsHtml(raters, includeLabel) {
    var countNum = parseInt(raters, 10) || 720;
    var countStr = countNum.toLocaleString('en-US');
    var starSvg = '<svg class="loox-icon" viewBox="0 0 24 24" data-lx-fill="full" aria-hidden="true"><use href="#looxicons-rating-icon"></use></svg>';
    var firstStarSvg = '<svg class="loox-icon" viewBox="0 0 24 24" data-lx-fill="full" aria-hidden="true" role="presentation"><title>' + countStr + ' reviews</title><use href="#looxicons-rating-icon"></use></svg>';
    var labelHtml = includeLabel !== false
      ? '<span class="loox-rating-label" aria-hidden="true">&nbsp;(' + countStr + ')</span>'
      : '';
    return '<div class="loox-rating-content">' + firstStarSvg + starSvg + starSvg + starSvg + starSvg + labelHtml + '</div>';
  }

  function hydrateAllLooxRatings(root) {
    var scope = root || document;
    scope.querySelectorAll('.loox-rating').forEach(function(el) {
      if (el.querySelector('svg')) return;
      var raters = el.getAttribute('data-raters') || '720';
      var hasSiblingReviewText = !!(el.parentElement && el.parentElement.querySelector('.review__text'));
      el.innerHTML = buildLooxStarsHtml(raters, !hasSiblingReviewText);
    });
  }

  /* ========================================================================
     1. GLOBAL NAVIGATION, SEARCH & DRAWER HELPERS
     ======================================================================== */
  window.disable_scrolling = function() {
    document.body.style.overflow = 'hidden';
  };
  window.enable_scrolling = function() {
    document.body.style.overflow = '';
  };
  window.show_search = function() {
    var pane = document.querySelector('.predict_search_pane');
    if (pane) {
      pane.style.display = 'block';
      var inp = pane.querySelector('input.search_query_inbox, input[type="search"], input[type="text"]');
      if (inp) setTimeout(function() { inp.focus(); }, 60);
    }
    window.disable_scrolling();
  };
  window.hide_search = function() {
    var pane = document.querySelector('.predict_search_pane');
    if (pane) pane.style.display = 'none';
    window.enable_scrolling();
  };
  window.show_menu = function() {
    var mob = document.getElementById('mob_menu_holder');
    if (mob) mob.classList.add('slided');
    document.querySelectorAll('.show_menu_btn').forEach(function(el) { el.style.display = 'none'; });
    document.querySelectorAll('.hide_menu_btn').forEach(function(el) { el.style.display = 'block'; });
    window.disable_scrolling();
  };
  window.hide_menu = function() {
    var mob = document.getElementById('mob_menu_holder');
    if (mob) mob.classList.remove('slided');
    document.querySelectorAll('.show_menu_btn').forEach(function(el) { el.style.display = 'block'; });
    document.querySelectorAll('.hide_menu_btn').forEach(function(el) { el.style.display = 'none'; });
    window.enable_scrolling();
  };
  window.open_cart_drawer = function() {
    CPCart.renderDrawer();
    document.querySelectorAll('.vue-cart.slider_cart_holder').forEach(function(holder) {
      holder.classList.add('active');
    });
    window.disable_scrolling();
  };
  window.close_cart_drawer = function() {
    document.querySelectorAll('.vue-cart.slider_cart_holder').forEach(function(holder) {
      holder.classList.remove('active');
    });
    window.enable_scrolling();
  };
  window.reBuildCart = function() {
    CPCart.renderDrawer();
    if (document.documentElement.getAttribute('data-cp-route') === 'cart') {
      CPCart.renderFullCartPage();
    }
  };
  window.handleButtonLoadingState = function() {};
  window.toggleView = function() {
    var content = document.querySelector('.ReadMore .ReadMore_content');
    var button = document.querySelector('.ReadMore_button button');
    if (!content || !button) return;
    if (content.classList.contains('ReadMore_content-all')) {
      content.classList.remove('ReadMore_content-all');
      button.innerHTML = 'Read more';
    } else {
      content.classList.add('ReadMore_content-all');
      button.innerHTML = 'Read less';
    }
  };
  window.scrollToId = function(scroll_id) {
    var el = document.querySelector('[data-scroll="' + scroll_id + '"]');
    if (el) el.scrollIntoView({ behavior: 'smooth', block: 'start' });
  };
  window.toggleTooltip = function(element) {
    var wrapper = element && element.closest ? element.closest('.tooltip-wrapper') : null;
    if (wrapper) wrapper.classList.toggle('active');
  };

  /* ========================================================================
     2. DUAL-SYNC CART ENGINE (LocalStorage + Native Shopify Cart API Bridge)
     ======================================================================== */
  var CART_STORAGE_KEY = 'cp_cart_items_v1';
  var CART_UPSELLS_KEY = 'cp_cart_upsells_v1';

  var CPCart = {
    getItems: function() {
      try {
        var raw = localStorage.getItem(CART_STORAGE_KEY);
        var list = raw ? JSON.parse(raw) : [];
        return Array.isArray(list) ? list : [];
      } catch (e) {
        return [];
      }
    },
    saveItems: function(items) {
      try {
        localStorage.setItem(CART_STORAGE_KEY, JSON.stringify(items));
      } catch (e) {}
      this.updateHeaderBadge();
    },
    getUpsells: function() {
      try {
        var raw = localStorage.getItem(CART_UPSELLS_KEY);
        return raw ? JSON.parse(raw) : { digitalDownload: false, skipArtwork: false, giftCard: false, giftCardAmount: 2500 };
      } catch (e) {
        return { digitalDownload: false, skipArtwork: false, giftCard: false, giftCardAmount: 2500 };
      }
    },
    saveUpsells: function(u) {
      try {
        localStorage.setItem(CART_UPSELLS_KEY, JSON.stringify(u));
      } catch (e) {}
    },
    toShopifyCartJson: function() {
      var items = this.getItems();
      return {
        token: 'cp_local_cart_token',
        note: null,
        attributes: {},
        original_total_price: this.getSubtotalCents(),
        total_price: this.getSubtotalCents(),
        total_discount: 0,
        total_weight: 0,
        item_count: this.getTotalCount(),
        items: items.map(function(it) {
          return {
            id: Number(it.id) || 40123609022550,
            key: it.key,
            title: it.title,
            price: Number(it.price) || 3995,
            line_price: (Number(it.price) || 3995) * (Number(it.quantity) || 1),
            quantity: Number(it.quantity) || 1,
            handle: it.handle || 'the-general-custom-pet-canvas',
            image: it.image || DEFAULT_PORTRAIT_IMG,
            variant_options: [it.option1 || '8" x 10"', it.option2 || 'Unframed'],
            properties: Object.assign({}, it.properties || {})
          };
        })
      };
    },
    addItem: function(item) {
      var items = this.getItems();
      var props = item.properties || {};
      var petKey = [props._pet_1_petName, props._pet_2_petName, props._pet_3_petName, props._pet_4_petName].filter(Boolean).join('-');
      var key = String(item.id) + '_' + petKey + '_' + (item.option1 || '') + '_' + (item.option2 || '') + '_' + (item.option3 || '');
      var existing = items.find(function(x) { return x.key.indexOf(key + '_') === 0 || x.key === key; });
      if (existing) {
        existing.quantity = (parseInt(existing.quantity, 10) || 1) + (parseInt(item.quantity, 10) || 1);
        if (item.properties) existing.properties = Object.assign({}, existing.properties || {}, item.properties);
        if (item.hasGiftFee) {
          existing.hasGiftFee = true;
          existing.giftFee = item.giftFee || 500;
        }
      } else {
        item.key = key + '_' + Date.now();
        item.quantity = parseInt(item.quantity, 10) || 1;
        items.push(item);
      }
      this.saveItems(items);
      this.renderDrawer();
      if (document.documentElement.getAttribute('data-cp-route') === 'cart') {
        this.renderFullCartPage();
      }
    },
    updateQuantity: function(key, newQty, newProps) {
      var items = this.getItems();
      var q = parseInt(newQty, 10);
      if (Number.isNaN(q) || q <= 0) {
        items = items.filter(function(x) { return x.key !== key && String(x.id) !== String(key); });
      } else {
        items.forEach(function(x) {
          if (x.key === key || String(x.id) === String(key)) {
            x.quantity = q;
            if (newProps && typeof newProps === 'object') {
              x.properties = Object.assign({}, x.properties || {}, newProps);
            }
          }
        });
      }
      this.saveItems(items);
      this.renderDrawer();
      if (document.documentElement.getAttribute('data-cp-route') === 'cart') {
        this.renderFullCartPage();
      }
    },
    removeGiftMessage: function(key) {
      var items = this.getItems();
      items.forEach(function(x) {
        if (x.key === key && x.properties) {
          if (x.properties['_Gift Message'] || x.properties['Gift Message']) {
            delete x.properties['_Gift Message'];
            delete x.properties['Gift Message'];
            x.hasGiftFee = false;
            x.giftFee = 0;
          }
        }
      });
      this.saveItems(items);
      this.renderDrawer();
      if (document.documentElement.getAttribute('data-cp-route') === 'cart') {
        this.renderFullCartPage();
      }
    },
    clearCart: function() {
      this.saveItems([]);
      this.saveUpsells({ digitalDownload: false, skipArtwork: false, giftCard: false, giftCardAmount: 2500 });
      this.renderDrawer();
      if (document.documentElement.getAttribute('data-cp-route') === 'cart') {
        this.renderFullCartPage();
      }
    },
    getTotalCount: function() {
      return this.getItems().reduce(function(sum, i) { return sum + (parseInt(i.quantity, 10) || 1); }, 0);
    },
    getSubtotalCents: function() {
      var sub = this.getItems().reduce(function(sum, i) {
        var line = (parseInt(i.price, 10) || 3995) * (parseInt(i.quantity, 10) || 1);
        var hasGift = i.hasGiftFee || (i.properties && (i.properties['_Gift Message'] || i.properties['Gift Message']));
        var gFee = hasGift ? (parseInt(i.giftFee, 10) || 500) : 0;
        return sum + line + gFee;
      }, 0);
      var u = this.getUpsells();
      if (this.getItems().length > 0) {
        if (u.digitalDownload) sub += 1000;
        if (u.skipArtwork) sub += 1500;
        if (u.giftCard) sub += (parseInt(u.giftCardAmount, 10) || 2500);
      }
      return sub;
    },
    updateHeaderBadge: function() {
      var count = this.getTotalCount();
      document.querySelectorAll('.cart_trigger').forEach(function(el) {
        el.setAttribute('cart_item_count', String(count));
        if (count > 0) el.classList.add('show_bubble');
        else el.classList.remove('show_bubble');
      });
    },
    buildLineItemsHtml: function(items) {
      return items.map(function(item, idx) {
        var props = item.properties || {};
        var petNames = [props._pet_1_petName, props._pet_2_petName, props._pet_3_petName, props._pet_4_petName, props['Pet Name']].filter(Boolean);
        var artistNotes = props._artist_notes || '';
        var giftMsg = props['_Gift Message'] || props['Gift Message'] || '';
        var uploadLater = props._upload_later || '';
        var petPhoto = props._pet_1_photo_data || props._pet_1 || '';
        var lineTotal = (parseInt(item.price, 10) || 3995) * (parseInt(item.quantity, 10) || 1);

        var titleParts = (item.title || 'The General - Custom Pet Canvas').split(' - ');
        var preTitle = titleParts[0] || item.title;
        var subTitle = titleParts[1] || item.productType || 'Custom Pet Portrait';

        var optionHeaderLabel = (item.optionsLabel && item.optionsLabel !== 'Size / Framing Option')
          ? item.optionsLabel
          : 'Size Framing Option';
        var variationParts = [item.option1, item.option2, item.option3].filter(Boolean);
        var variationsText = variationParts.length ? variationParts.join(' ') : '8" x 10" Unframed';

        var extraOptionsHtml = '';
        if (petNames.length > 0) {
          extraOptionsHtml +=
            '<div class="slider_cart_item__optionName">' + (petNames.length > 1 ? 'Pets\' Names' : 'Pet\'s Name') + '</div>' +
            '<div class="slider_cart_item-options__variations">' + escapeHtml(petNames.join(', ')) + '</div>';
        }
        if (artistNotes) {
          extraOptionsHtml +=
            '<div class="slider_cart_item__optionName">Artist Notes</div>' +
            '<div class="slider_cart_item-options__variations">' + escapeHtml(artistNotes) + '</div>';
        }
        if (uploadLater && !petPhoto) {
          extraOptionsHtml +=
            '<div class="slider_cart_item__optionName">Photo</div>' +
            '<div class="slider_cart_item-options__variations">' + escapeHtml(uploadLater) + '</div>';
        }
        if (props._Extras) {
          extraOptionsHtml +=
            '<div class="slider_cart_item__optionName">Extras</div>' +
            '<div class="slider_cart_item-options__variations">' + escapeHtml(props._Extras) + '</div>';
        }

        var portraitHtml = (petPhoto && petPhoto.indexOf('data:image') === 0) || (petPhoto && petPhoto.indexOf('http') !== -1) || (petPhoto && petPhoto.indexOf('//') === 0)
          ? '<img src="' + escapeHtml(petPhoto) + '" alt="Uploaded Pet Photo">'
          : '';

        var giftItemHtml = '';
        if (giftMsg) {
          giftItemHtml =
            '<div class="tw-gift-message-cart-item">' +
              '<div class="tw-gift-message-cart-item__icon">' +
                '<svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 12 20 22 4 22 4 12"></polyline><rect x="2" y="7" width="20" height="5"></rect><line x1="12" y1="22" x2="12" y2="7"></line><path d="M12 7H7.5a2.5 2.5 0 0 1 0-5C11 2 12 7 12 7z"></path><path d="M12 7h4.5a2.5 2.5 0 0 0 0-5C13 2 12 7 12 7z"></path></svg>' +
              '</div>' +
              '<div class="tw-gift-message-cart-item__content">' +
                '<p class="tw-gift-message-cart-item__title">Gift Message (<span class="money">+$5.00</span>)</p>' +
                '<span class="tw-gift-message-cart-item__message">' + escapeHtml(giftMsg) + '</span>' +
              '</div>' +
              '<div class="tw-gift-message-cart-item__actions">' +
                '<button type="button" class="tw-gift-message-cart-item__edit" data-gift-message-edit data-line-key="' + escapeHtml(item.key) + '" data-gift-message="' + escapeHtml(giftMsg) + '" data-line-quantity="' + item.quantity + '" aria-label="Edit gift message">' +
                  '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="#3a3a3a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path></svg>' +
                '</button>' +
                '<button type="button" class="tw-gift-message-cart-item__remove" data-cp-gift-remove="' + escapeHtml(item.key) + '" aria-label="Remove gift message">' +
                  '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 700 700"><path fill="currentColor" d="M124.2,185.7h472.5v-41.2H103.3v41.2H124.2z M226.3,329.7c0-11.8,9.2-20.9,20.9-20.9c11.1,0,20.3,9.2,20.3,20.9l0.7,204.8c0,11.8-9.2,20.9-20.3,20.9c-11.8,0-20.9-9.2-20.9-20.9L226.3,329.7z M431.8,329.7c0-11.8,9.2-20.9,20.3-20.9c11.8,0,20.9,9.2,20.9,20.9l0.7,204.8c0,11.8-9.2,20.9-20.9,20.9c-11.1,0-20.3-9.2-20.3-20.9L431.8,329.7z M329.1,329.7c0-11.8,9.2-20.9,20.3-20.9c11.8,0,20.9,9.2,20.9,20.9l0.7,204.8c0,11.8-9.2,20.9-20.3,20.9c-11.8,0-20.9-9.2-20.9-20.9L329.1,329.7z M555.5,227h-411v410.3h411V227z"/></svg>' +
                '</button>' +
              '</div>' +
            '</div>';
        }

        return (
          '<li class="slider_cart_item__container " time="" type="step_product">' +
            '<div class="slider_cart_item vue-cart__padding" data-id="' + (idx + 1) + '" data-product-id="' + escapeHtml(item.id) + '" data-is-digitalDownload="false" data-is-skipArtwork="false" data-is-canvas="true" data-is-fre-gift="false" data-quantity="' + item.quantity + '">' +
              '<div class="slider_cart_item__data" key="' + escapeHtml(item.key) + '" p_id="' + escapeHtml(item.id) + '" p_type="' + escapeHtml(item.productType || 'Canvas') + '">' +
                '<div class="slider_cart_item__image-title-wrapper flex f-vertical-top slider_cart_item__col-1">' +
                  '<div class="slider_cart_item__image">' +
                    '<a href="/products/' + escapeHtml(item.handle || 'the-general-custom-pet-canvas') + '">' +
                      '<img src="' + escapeHtml(item.image || DEFAULT_PORTRAIT_IMG) + '" alt="' + escapeHtml(item.title) + '">' +
                    '</a>' +
                  '</div>' +
                  '<div class="slider_cart_item__title-wrapper">' +
                    '<div class="slider_cart_item__meta-row">' +
                      '<div class="slider_cart_item__meta-row__content">' +
                        '<div class="slider_cart_item__rating">' +
                          '<div class="loox-rating" data-id="3958383771734" data-rating="5" data-raters="2935">' + buildLooxStarsHtml(2935, false) + '</div>' +
                          '<a href="#looxReviews" class="review__text">2935 Reviews</a>' +
                        '</div>' +
                      '</div>' +
                      '<button type="button" quantity="0" data-cp-cart-qty="0" data-cp-cart-key="' + escapeHtml(item.key) + '" class="update_line_item slider_cart_item__remove--text-link btn--no-styling">' +
                        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 700 700" aria-hidden="true"><path fill="#CB2525" d="M124.2,185.7h472.5v-41.2H103.3v41.2H124.2z M226.3,329.7c0-11.8,9.2-20.9,20.9-20.9c11.1,0,20.3,9.2,20.3,20.9l0.7,204.8c0,11.8-9.2,20.9-20.3,20.9c-11.8,0-20.9-9.2-20.9-20.9L226.3,329.7z M431.8,329.7c0-11.8,9.2-20.9,20.3-20.9c11.8,0,20.9,9.2,20.9,20.9l0.7,204.8c0,11.8-9.2,20.9-20.9,20.9c-11.1,0-20.3-9.2-20.3-20.9L431.8,329.7z M329.1,329.7c0-11.8,9.2-20.9,20.3-20.9c11.8,0,20.9,9.2,20.9,20.9l0.7,204.8c0,11.8-9.2,20.9-20.3,20.9c-11.8,0-20.9-9.2-20.9-20.9L329.1,329.7z M452.7,103.3V83c0-5.2-2.6-10.5-5.9-14.4c-3.9-3.9-9.2-5.9-14.4-5.9H267.5c-5.2,0-10.5,2-14.4,5.9c-3.3,3.9-5.9,9.2-5.9,14.4v20.3H452.7L452.7,103.3z M206,103.3V83c0-17,7.2-32.1,18.3-43.2c11.1-11.1,26.8-18.3,43.2-18.3h164.9c16.4,0,32.1,7.2,43.2,18.3C486.8,50.9,494,66,494,83v20.3h123c11.1,0,20.3,9.8,20.3,20.9V206c0,11.8-9.2,20.9-20.3,20.9h-20.3v431.2c0,11.1-9.8,20.3-20.9,20.3H124.2c-11.1,0-20.9-9.2-20.9-20.3V227H83c-11.1,0-20.3-9.2-20.3-20.9v-81.8c0-11.1,9.2-20.9,20.3-20.9H206L206,103.3z M555.5,227h-411v410.3h411V227z"/></svg>' +
                      '</button>' +
                    '</div>' +
                    '<span class="slider_cart_item__pre-title">' + escapeHtml(preTitle) + '</span>' +
                    '<span class="slider_cart_item__title">' + escapeHtml(subTitle) + '</span>' +
                    '<div class="slider_cart_item-options">' +
                      '<div class="slider_cart_item__optionName">' + escapeHtml(optionHeaderLabel) + '</div>' +
                      '<div class="slider_cart_item-options__variations">' + escapeHtml(variationsText) + '</div>' +
                      extraOptionsHtml +
                    '</div>' +
                    '<div class="slider_cart_item-footer">' +
                      '<div class="slider_cart_item-footer__portrait slider_cart_item__col-4">' + portraitHtml + '</div>' +
                      '<div class="slider_cart_item-footer__quantity slider_cart_item__col-4">' +
                        '<div class="slider_cart_item-footer__quantity-container">' +
                          '<button type="button" quantity="' + (item.quantity - 1) + '" data-cp-cart-qty="' + (item.quantity - 1) + '" data-cp-cart-key="' + escapeHtml(item.key) + '" class="update_line_item slider_cart_item-footer__quantity--decrease btn--no-styling">－</button>' +
                          '<input value="' + item.quantity + '" class="productQuantity" data-quantity-input="" min="1" name="quantity" pattern="[0-9]*" type="number" readonly>' +
                          '<button type="button" quantity="' + (item.quantity + 1) + '" data-cp-cart-qty="' + (item.quantity + 1) + '" data-cp-cart-key="' + escapeHtml(item.key) + '" class="update_line_item slider_cart_item-footer__quantity--increase btn--no-styling">＋</button>' +
                        '</div>' +
                      '</div>' +
                      '<div class="slider_cart_item-footer__price slider_cart_item__col-3"><span>' + formatMoney(lineTotal) + '</span></div>' +
                    '</div>' +
                    giftItemHtml +
                  '</div>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</li>'
        );
      }).join('');
    },
    renderDrawer: function() {
      var items = this.getItems();
      var u = this.getUpsells();
      var count = this.getTotalCount();
      var subtotalCents = this.getSubtotalCents();
      var freeThreshold = 7500;
      var progressPct = Math.min(100, Math.round((subtotalCents / freeThreshold) * 100));
      var remainingCents = Math.max(0, freeThreshold - subtotalCents);

      document.querySelectorAll('.slider_cart_header__heading').forEach(function(headingEl) {
        headingEl.textContent = 'My Cart(' + count + ')';
      });

      document.querySelectorAll('.vue-cart__FreeShipping--header').forEach(function(fsMsgEl) {
        if (remainingCents === 0 && count > 0) {
          fsMsgEl.innerHTML = '<span class="custom_inline_message_rv">Congrats! You\'ve earned <strong>Free Shipping</strong></span>';
        } else if (count === 0) {
          fsMsgEl.innerHTML = '<span class="custom_inline_message_rv">Free Shipping on orders over <strong>$75.00</strong></span>';
        } else {
          fsMsgEl.innerHTML = '<span class="custom_inline_message_rv">You\'re only <strong>' + formatMoney(remainingCents) + '</strong> away from <strong>Free Shipping</strong></span>';
        }
      });
      document.querySelectorAll('.vue-cart__FreeShipping--progressBar').forEach(function(fsBarEl) {
        fsBarEl.style.width = progressPct + '%';
      });

      var self = this;
      document.querySelectorAll('.slider_cart_products').forEach(function(listEl) {
        var rootCart = listEl.closest('.vue-cart__inner') || document;
        var footerEl = rootCart.querySelector('.slider_cart_footer');

        if (items.length === 0) {
          listEl.innerHTML =
            '<style>.slider_cart_products .loox-rating .loox-rating-label { display: none !important; }</style>' +
            '<li class="slider_cart_item__container" style="list-style:none; text-align:center; padding: 48px 20px;">' +
              '<p style="font: normal normal bold 20px/26px Assistant, sans-serif; color:#3A3A3A; margin-bottom:16px;">Your cart is currently empty.</p>' +
              '<a href="/collections/best-sellers" onclick="close_cart_drawer();" class="btn" style="display:inline-flex; align-items:center; justify-content:center; background:#FF97AB; color:#fff; font:normal normal bold 16px/20px Asap, sans-serif; padding:14px 32px; border-radius:28px; text-decoration:none;">SHOP BEST SELLERS</a>' +
            '</li>';
          if (footerEl) footerEl.style.display = 'none';
        } else {
          if (footerEl) footerEl.style.display = '';
          listEl.innerHTML =
            '<style>.slider_cart_products .loox-rating .loox-rating-label { display: none !important; }</style>' +
            self.buildLineItemsHtml(items);
        }
      });

      document.querySelectorAll('#download-checkbox, #download-checkbox-page').forEach(function(dlCheck) {
        dlCheck.checked = !!u.digitalDownload;
      });
      document.querySelectorAll('#skip-checkbox, #skip-checkbox-page').forEach(function(skipCheck) {
        skipCheck.checked = !!u.skipArtwork;
      });
      document.querySelectorAll('.slider_cart_subtotal__total_price').forEach(function(subPriceEl) {
        subPriceEl.textContent = formatMoney(subtotalCents);
        subPriceEl.setAttribute('data-total-price', String(subtotalCents));
      });

      this.updateHeaderBadge();
    },
    renderFullCartPage: function() {
      var container = document.getElementById('cp-full-cart-page-container');
      if (!container) return;

      document.body.className = 'template-cart nothomepage';
      document.title = 'Your Shopping Cart – Crown & Paw';

      if (!container.dataset.cpHydrated && window.CP_PAGES && window.CP_PAGES.cart) {
        container.dataset.cpHydrated = 'true';
        container.innerHTML = window.CP_PAGES.cart;
        promoteLazyImages(container);
        if (window.jQuery && window.jQuery.fn && window.jQuery.fn.slick) {
          try {
            window.jQuery(container).find('.testimonial_slider').not('.slick-initialized').slick({
              dots: true,
              infinite: false,
              speed: 500,
              slidesToShow: 5,
              slidesToScroll: 5,
              adaptiveHeight: true,
              prevArrow: window.jQuery(container).find('.favourites_arrow.left'),
              nextArrow: window.jQuery(container).find('.favourites_arrow.right'),
              responsive: [
                {
                  breakpoint: 900,
                  settings: {
                    slidesToShow: 1.8,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false
                  }
                },
                {
                  breakpoint: 750,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    variableWidth: true,
                    dots: false,
                    arrows: false
                  }
                }
              ]
            });
          } catch (e) {}
        }
      }

      var pageCartHolder = container.querySelector('.vue-cart--page-cart');
      if (pageCartHolder) {
        var items = this.getItems();
        var count = this.getTotalCount();
        var subtotalCents = this.getSubtotalCents();
        var savingsCents = items.reduce(function(sum, it) {
          var qty = parseInt(it.quantity, 10) || 1;
          var unit = parseInt(it.price, 10) || 6995;
          var comp = parseInt(it.compare_at_price, 10) || (unit + 1000);
          return sum + Math.max(0, comp - unit) * qty;
        }, 0);

        var DAYS = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
        var MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
        var now = new Date();
        var deliverDate = new Date(now.getTime() + 4 * 24 * 60 * 60 * 1000);
        var shippingHtml = items.length > 0
          ? 'YOUR ARTWORK will be ready by <strong>' + DAYS[deliverDate.getUTCDay()] + ', ' + deliverDate.getUTCDate() + ' ' + MONTHS[deliverDate.getUTCMonth()] + ' ' + deliverDate.getUTCFullYear() + '</strong> if you order in the next <strong>9 hours 27 mins</strong>'
          : '';
        var countdownCartHtml = items.length > 0
          ? 'High demand. Your order is reserved for <span class="Cart__Countdown">09:59s</span>'
          : '';
        var headingText = items.length > 0 ? 'My Cart (' + count + ')' : 'My Cart ';

        var tbodyRowsHtml = items.map(function(item) {
          var qty = parseInt(item.quantity, 10) || 1;
          var unitPrice = parseInt(item.price, 10) || 6995;
          var unitCompare = parseInt(item.compare_at_price, 10) || (unitPrice + 1000);
          var linePrice = unitPrice * qty;
          var lineCompare = unitCompare * qty;
          var titleParts = (item.title || 'The General - Custom Pet Canvas').split(' - ');
          var preTitle = titleParts[0] || item.title;
          var subTitle = titleParts[1] || item.productType || 'Custom Pet Portrait';
          var variationParts = [item.option1, item.option2, item.option3].filter(Boolean);
          var variationsText = variationParts.length ? variationParts.join(' / ') : '8" x 10" / Unframed';
          var trashSvg = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 700 700" aria-hidden="true"><path fill="#CB2525" d="M124.2,185.7h472.5v-41.2H103.3v41.2H124.2z M226.3,329.7c0-11.8,9.2-20.9,20.9-20.9c11.1,0,20.3,9.2,20.3,20.9l0.7,204.8c0,11.8-9.2,20.9-20.3,20.9c-11.8,0-20.9-9.2-20.9-20.9L226.3,329.7z M431.8,329.7c0-11.8,9.2-20.9,20.3-20.9c11.8,0,20.9,9.2,20.9,20.9l0.7,204.8c0,11.8-9.2,20.9-20.9,20.9c-11.1,0-20.3-9.2-20.3-20.9L431.8,329.7z M329.1,329.7c0-11.8,9.2-20.9,20.3-20.9c11.8,0,20.9,9.2,20.9,20.9l0.7,204.8c0,11.8-9.2,20.9-20.3,20.9c-11.8,0-20.9-9.2-20.9-20.9L329.1,329.7z M452.7,103.3V83c0-5.2-2.6-10.5-5.9-14.4c-3.9-3.9-9.2-5.9-14.4-5.9H267.5c-5.2,0-10.5,2-14.4,5.9c-3.3,3.9-5.9,9.2-5.9,14.4v20.3H452.7L452.7,103.3z M206,103.3V83c0-17,7.2-32.1,18.3-43.2c11.1-11.1,26.8-18.3,43.2-18.3h164.9c16.4,0,32.1,7.2,43.2,18.3C486.8,50.9,494,66,494,83v20.3h123c11.1,0,20.3,9.8,20.3,20.9V206c0,11.8-9.2,20.9-20.3,20.9h-20.3v431.2c0,11.1-9.8,20.3-20.9,20.3H124.2c-11.1,0-20.9-9.2-20.9-20.3V227H83c-11.1,0-20.3-9.2-20.3-20.9v-81.8c0-11.1,9.2-20.9,20.3-20.9H206L206,103.3z M555.5,227h-411v410.3h411V227z"/></svg>';

          return (
            '<tr class="vue-cart-item">' +
              '<td>' +
                '<div class="vue-cart-item__data">' +
                  '<div class="vue-cart-item__image-title-wrapper flex f-vertical-top vue-cart-item__col-1">' +
                    '<div class="vue-cart-item__image">' +
                      '<a href="/products/' + escapeHtml(item.handle || 'the-general-custom-pet-canvas') + '">' +
                        '<img src="' + escapeHtml(item.image || DEFAULT_PORTRAIT_IMG) + '" alt="' + escapeHtml(item.title) + '">' +
                      '</a>' +
                    '</div>' +
                    '<div class="vue-cart-item__title-wrapper">' +
                      '<div class="vue-cart-item__rating">' +
                        '<div class="loox-rating" data-id="3958383771734" data-rating="5" data-raters="2935">' + buildLooxStarsHtml(2935, false) + '</div>' +
                        '<a href="#looxReviews" class="review__text">2935 Reviews</a>' +
                      '</div>' +
                      '<span class="vue-cart-item__pre-title">' + escapeHtml(preTitle) + '</span>' +
                      '<span class="vue-cart-item__title">' + escapeHtml(subTitle) + '</span>' +
                      '<div class="vue-cart-item-options">' +
                        '<div class="vue-cart-item__optionName">Size / Framing Option:&nbsp;</div>' +
                        '<div class="vue-cart-item-options__variations">' + escapeHtml(variationsText) + '</div>' +
                      '</div>' +
                    '</div>' +
                  '</div>' +
                '</div>' +
              '</td>' +
              '<td>' +
                '<div>' +
                  '<button type="button" data-cp-cart-qty="0" data-cp-cart-key="' + escapeHtml(item.key) + '" class="update_line_item vue-cart-item__remove--text-link btn--no-styling">' + trashSvg + '</button>' +
                '</div>' +
              '</td>' +
              '<td>' +
                '<div>' +
                  '<div class="vue-cart-item-footer__quantity-container">' +
                    '<div class="vue-cart-item-footer__quantity">' +
                      '<button type="button" data-cp-cart-qty="' + (qty - 1) + '" data-cp-cart-key="' + escapeHtml(item.key) + '" class="update_line_item vue-cart-item-footer__quantity--decrease btn--no-styling">-</button>' +
                      '<input type="number" readonly value="' + qty + '" class="productQuantity">' +
                      '<button type="button" data-cp-cart-qty="' + (qty + 1) + '" data-cp-cart-key="' + escapeHtml(item.key) + '" class="update_line_item vue-cart-item-footer__quantity--increase btn--no-styling">+</button>' +
                    '</div>' +
                  '</div>' +
                '</div>' +
              '</td>' +
              '<td>' +
                '<div>' +
                  '<div class="vue-cart-item-footer__price">' +
                    '<span class="price"><span class="money">' + formatMoney(unitPrice) + '</span></span>' +
                    '<span class="claim-line-through"><span class="money">' + formatMoney(unitCompare) + '</span></span>' +
                  '</div>' +
                '</div>' +
              '</td>' +
              '<td>' +
                '<div>' +
                  '<div class="vue-cart-item-footer__price">' +
                    '<span class="price"><span class="money">' + formatMoney(linePrice) + '</span></span>' +
                    '<span class="claim-line-through"><span class="money">' + formatMoney(lineCompare) + '</span></span>' +
                  '</div>' +
                '</div>' +
              '</td>' +
            '</tr>'
          );
        }).join('');

        var mobileItemsHtml = items.map(function(item) {
          var qty = parseInt(item.quantity, 10) || 1;
          var unitPrice = parseInt(item.price, 10) || 6995;
          var linePrice = unitPrice * qty;
          var titleParts = (item.title || 'The General - Custom Pet Canvas').split(' - ');
          var preTitle = titleParts[0] || item.title;
          var subTitle = titleParts[1] || item.productType || 'Custom Pet Portrait';
          var variationParts = [item.option1, item.option2, item.option3].filter(Boolean);
          var variationsText = variationParts.length ? variationParts.join(' / ') : '8" x 10" / Unframed';
          return (
            '<li class="vue-cart-item vue-cart__padding">' +
              '<div class="vue-cart-item__data">' +
                '<div class="vue-cart-item__image-title-wrapper flex f-vertical-top">' +
                  '<div class="vue-cart-item__image">' +
                    '<img src="' + escapeHtml(item.image || DEFAULT_PORTRAIT_IMG) + '" alt="' + escapeHtml(item.title) + '">' +
                  '</div>' +
                  '<div class="vue-cart-item__title-wrapper">' +
                    '<div class="vue-cart-item__title-price">' +
                      '<div>' +
                        '<span class="vue-cart-item__pre-title">' + escapeHtml(preTitle) + '</span>' +
                        '<span class="vue-cart-item__title">' + escapeHtml(subTitle) + '</span>' +
                      '</div>' +
                      '<div class="vue-cart-item-footer__price"><span class="price"><span class="money">' + formatMoney(linePrice) + '</span></span></div>' +
                    '</div>' +
                    '<div class="vue-cart-item-options">' +
                      '<div class="vue-cart-item__optionName">Size / Framing Option:&nbsp;</div>' +
                      '<div class="vue-cart-item-options__variations">' + escapeHtml(variationsText) + '</div>' +
                    '</div>' +
                  '</div>' +
                '</div>' +
              '</div>' +
            '</li>'
          );
        }).join('');

        var paymentIconsHtml = document.querySelector('#shopify-section-cart-drawer .slider_cart_footer')
          ? ''
          : '';

        pageCartHolder.innerHTML =
          '<div id="shopify-section-cart-template" class="shopify-section">' +
            '<style>' +
              '#mr-div-embedded-cp-cvb-page{display:none!important;}' +
              '.vue-cart--page-cart .cdd_text,.vue-cart--page-cart .cdd_percent{font-size:15px;line-height:23px;font-family:Assistant;font-weight:700;}' +
              '.vue-cart--page-cart .cart_dfy_discount{display:flex;justify-content:space-between;align-items:center;font-size:18px;line-height:23px;color:#ff97ab;font-family:Assistant;font-weight:700;}' +
              '.vue-cart-subtotal-wrapper .discount-text{font-size:16px;line-height:25px;color:#000;background:#D9E6E6;font-weight:700;padding:8px 0;border-radius:8px;width:100%;display:block;text-align:center;margin:auto;margin-top:20px;border:1px dashed #8a8a8a;}' +
              'tr.free_mug .vue-cart-item-footer__quantity-container{pointer-events:none;}' +
              '.free_mug .vue-cart-item__remove--text-link{visibility:hidden;}' +
            '</style>' +
            '<div class="vue-cart vue-cart--page-cart initialised">' +
              '<div class="vue-cart-countdown">' +
                '<svg xmlns="http://www.w3.org/2000/svg" width="32px" height="32px" viewBox="0 0 32 32" id="Lager_44" data-name="Lager 44"><g id="Group_15" data-name="Group 15"><path id="Path_51" data-name="Path 51" d="M16,0A16,16,0,1,0,32,16,16,16,0,0,0,16,0Zm0,28A12,12,0,1,1,28,16,12.013,12.013,0,0,1,16,28Z" fill="#040505"></path><path id="Path_52" data-name="Path 52" d="M20.02,16H17a1,1,0,0,1-1-1V11.98A1.979,1.979,0,0,0,14.02,10h-.04A1.979,1.979,0,0,0,12,11.98v6.04A1.979,1.979,0,0,0,13.98,20h6.04A1.979,1.979,0,0,0,22,18.02v-.04A1.979,1.979,0,0,0,20.02,16Z" fill="#040505"></path></g></svg>' +
                '<div class="vue-cart-countdown__Cart">' + countdownCartHtml + '</div>' +
              '</div>' +
              '<div class="vue-cart__inner">' +
                '<div class="vue-cart__inner-left">' +
                  '<div class="vue-cart__Shipping-countdown">' +
                    '<div class="vue-cart__Shipping-icon"><svg xmlns="http://www.w3.org/2000/svg" version="1.1" id="Layer_1" x="0px" y="0px" viewBox="0 0 700 700" xml:space="preserve"><g><path d="M235.5,475.4c2.2,8.2,2.2,16.9,0,25.1c-3.7,14.5-13.7,26.5-27.2,32.9c-13.5,6.4-29.1,6.4-42.7,0c-13.5-6.4-23.5-18.4-27.2-32.9c-2.2-8.2-2.2-16.9,0-25.1c0-0.1,0-0.1,0.1-0.3c0.2-1.3,0.6-2.5,1.1-3.6c1.8-5.2,4.4-10.1,7.8-14.4c0.8-1.1,1.7-2.1,2.6-3c0.8-1,1.7-1.9,2.6-2.8c8-7.5,18.2-12.1,29.1-13.3c1.8-0.1,3.4-0.3,5.1-0.3c1.8,0,3.4,0.1,5.1,0.3h0c10.9,1.2,21.1,5.8,29.1,13.3c1,0.8,1.9,1.8,2.6,2.8c1,0.9,1.9,1.9,2.6,3c3.4,4.3,6,9.2,7.8,14.4c0.5,1.2,0.9,2.4,1.1,3.6C235.5,475.3,235.5,475.3,235.5,475.4L235.5,475.4z M437.8,161.9H86.7c-6.9,0-12.5,5.6-12.5,12.5v313.5c0,6.9,5.6,12.5,12.5,12.5h26.2c-0.8-4.1-1.2-8.3-1.1-12.5c0-5.2,0.5-10.4,1.6-15.5v-7.8l3.3-3.1h0c2.6-7.1,6.4-13.7,11-19.7c1.2-1.7,2.5-3.3,3.9-4.8c1.5-1.6,3-3.1,4.6-4.5c11.9-11,27-17.8,43.1-19.4c3.3-0.3,5.4-0.4,7.7-0.4c2.3,0,4.4,0.1,6.5,0.3c16.7,1.5,32.4,8.5,44.6,19.9c1.5,1.3,3,2.7,4.3,4.3c1.5,1.5,2.9,3.2,4.1,4.9c4.5,5.8,8.1,12.4,10.7,19.3l3.3,3l0.1,7.8l0,0c1.1,5.2,1.7,10.5,1.6,15.8c0,4.2-0.3,8.4-1,12.5h177.7c-0.8-4.1-1.1-8.3-1.1-12.5c-0.1-14.8,4.3-29.2,12.5-41.5v-272c0-3.3-1.3-6.5-3.7-8.9C444.3,163.2,441.1,161.9,437.8,161.9L437.8,161.9z M475.4,225.2v112.2h142.5c-9.9-30.7-28.8-57.8-54.1-77.8C538.4,239.7,507.6,227.7,475.4,225.2L475.4,225.2z M613.3,425.2h12.5v-37.6c0-8.4-0.6-16.8-1.9-25.1H475.4v60.3c11.4-6.7,24.4-10.2,37.6-10.2c19.9,0,39.1,7.9,53.2,22.1c14.1,14.1,22,33.2,22.1,53.2c0,4.2-0.4,8.4-1.1,12.5h26.2c6.9,0,12.5-5.6,12.5-12.5v-37.6h-12.5c-6.9,0-12.5-5.6-12.5-12.5C600.8,430.9,606.4,425.2,613.3,425.2L613.3,425.2z M561.7,475.7c-0.1-0.3-0.1-0.4-0.3-0.5c-0.2-1.3-0.6-2.5-1.1-3.6c-2.1-6.5-5.7-12.5-10.4-17.4c-0.8-1-1.7-1.9-2.6-2.8c-9.3-8.7-21.5-13.6-34.2-13.5c-1.4,0-2.9,0-4.3,0.2c-1,0-2,0.1-3,0.4c-2.2,0.3-4.4,0.7-6.5,1.4c-0.9,0.3-1.6,0.5-2.4,0.8c-5,1.6-9.6,4.1-13.8,7.3c-1.3,0.9-2.5,1.9-3.6,3c-0.3,0.1-0.5,0.3-0.6,0.5c-1.2,1.1-2.4,2.3-3.4,3.5c-8.1,9.1-12.5,20.9-12.5,33.1c0,4.2,0.5,8.4,1.6,12.4c-0.5,0.1-1.1,0.1-1.6,0.1h1.6c3.7,14.5,13.7,26.5,27.2,32.9c13.5,6.4,29.1,6.4,42.7,0c13.5-6.4,23.5-18.4,27.2-32.9c0.1-0.1,0.1-0.2,0.1-0.3c0.4-1.5,0.6-3,0.9-4.5c0.8-5.1,0.8-10.4,0-15.5C562.3,478.7,562.1,477.2,561.7,475.7L561.7,475.7z"/></g></svg></div>' +
                    '<div class="vue-cart-countdown__Shipping">' + shippingHtml + '</div>' +
                  '</div>' +
                  '<div class="vue-cart-items">' +
                    '<div class="vue-cart-header page-width vue-cart__padding">' +
                      '<p class="vue-cart-header__heading">' + headingText + '</p>' +
                    '</div>' +
                    '<div class="vue-cart__body">' +
                      '<div class="vue-cart__item-list-header above-mobile-large">' +
                        '<table>' +
                          '<thead><tr><th></th><th></th><th>Quantity</th><th>Unit Price</th><th>Total</th></tr></thead>' +
                          '<tbody>' + tbodyRowsHtml + '</tbody>' +
                        '</table>' +
                      '</div>' +
                      '<ul class="vue-cart-products mobile-large-only">' + mobileItemsHtml + '</ul>' +
                      '<div class="vue-cart__add-more">' +
                        '<a href="/collections/best-sellers">Keep shopping for custom gifts</a>' +
                      '</div>' +
                    '</div>' +
                  '</div>' +
                '</div>' +
                '<div class="vue-cart__inner-right">' +
                  '<div class="vue-cart-footer vue-cart__padding">' +
                    '<div class="page-width vue-cart-footer__container">Order Summary</div>' +
                    '<div class="vue-cart-subtotal-wrapper">' +
                      '<div class="vue-cart-subtotals">' +
                        '<div class="vue-cart-subtotal__saving">' +
                          '<div class="vue-cart-subtotal__label">Savings Total</div>' +
                          '<div class="vue-cart-subtotal__price"><span class="price"><span class="money">' + formatMoney(savingsCents) + '</span></span></div>' +
                        '</div>' +
                        '<div class="vue-cart-subtotal">' +
                          '<div class="vue-cart-subtotal__label">Subtotal</div>' +
                          '<div class="vue-cart-subtotal__price" id="checkout-price-wrapper">' +
                            '<div class="vue-cart-item-footer__subtotal_price vue-cart-item__col-2">' +
                              '<span class="price"><span class="money">' + formatMoney(subtotalCents) + '</span></span>' +
                            '</div>' +
                          '</div>' +
                        '</div>' +
                        '<div class="vue-cart-subtotal__shipping">' +
                          '<div class="vue-cart-subtotal__label">Shipping</div>' +
                          '<div class="vue-cart-subtotal__price">CHOOSE AT CHECKOUT</div>' +
                        '</div>' +
                      '</div>' +
                    '</div>' +
                    '<div class="vue-cart-footer-button">' +
                      '<div class="vue-cart-links">' +
                        '<a href="/checkout" class="btn vue-cart-links__checkout">' +
                          '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-lock" viewBox="0 0 17 20"><path fill="#FFF" d="M15.725 8.333H15.3V6.875C15.3 3.02 12.313 0 8.5 0 4.687 0 1.7 3.02 1.7 6.875v1.458h-.425C.571 8.333 0 8.893 0 9.583v9.167C0 19.44.571 20 1.275 20h14.45c.704 0 1.275-.56 1.275-1.25V9.583c0-.69-.571-1.25-1.275-1.25zM4.25 6.875C4.25 4.381 6.077 2.5 8.5 2.5s4.25 1.88 4.25 4.375v1.458h-8.5V6.875zm5.95 8.142c0 .91-.754 1.65-1.683 1.65h-.034c-.93 0-1.683-.74-1.683-1.65v-1.7c0-.911.754-1.65 1.683-1.65h.034c.93 0 1.683.739 1.683 1.65v1.7z"/></svg>' +
                          '<span>PROCEED TO CHECKOUT</span>' +
                        '</a>' +
                      '</div>' +
                      '<div class="vue-cart--payments">' +
                        '<svg class="icon icon--full-color" viewBox="0 0 38 24" width="38" height="24"><rect width="38" height="24" rx="3" fill="#0071CE"/></svg>' +
                        '<svg class="icon icon--full-color" viewBox="0 0 38 24" width="38" height="24"><rect width="38" height="24" rx="3" fill="#000"/></svg>' +
                        '<svg class="icon icon--full-color" viewBox="0 0 38 24" width="38" height="24"><rect width="38" height="24" rx="3" fill="#3086C8"/></svg>' +
                        '<svg class="icon icon--full-color" viewBox="0 0 38 24" width="38" height="24"><rect width="38" height="24" rx="3" fill="#F48120"/></svg>' +
                        '<svg class="icon icon--full-color" viewBox="0 0 38 24" width="38" height="24"><rect width="38" height="24" rx="3" fill="#4285F4"/></svg>' +
                        '<svg class="icon icon--full-color" viewBox="0 0 38 24" width="38" height="24"><rect width="38" height="24" rx="3" fill="#FFA8CD"/></svg>' +
                        '<svg class="icon icon--full-color" viewBox="0 0 38 24" width="38" height="24"><rect width="38" height="24" rx="3" fill="#EB001B"/></svg>' +
                        '<svg class="icon icon--full-color" viewBox="0 0 38 24" width="38" height="24"><rect width="38" height="24" rx="3" fill="#1C1C1C"/></svg>' +
                        '<svg class="icon icon--full-color" viewBox="0 0 38 24" width="38" height="24"><rect width="38" height="24" rx="3" fill="#003087"/></svg>' +
                        '<svg class="icon icon--full-color" viewBox="0 0 38 24" width="38" height="24"><rect width="38" height="24" rx="3" fill="#ef4323"/></svg>' +
                        '<svg class="icon icon--full-color" viewBox="0 0 38 24" width="38" height="24"><rect width="38" height="24" rx="3" fill="#5A31F4"/></svg>' +
                        '<svg class="icon icon--full-color" viewBox="0 0 38 24" width="38" height="24"><rect width="38" height="24" rx="3" fill="#005B9A"/></svg>' +
                        '<svg class="icon icon--full-color" viewBox="0 0 38 24" width="38" height="24"><rect width="38" height="24" rx="3" fill="#0B53BF"/></svg>' +
                        '<svg class="icon icon--full-color" viewBox="0 0 38 24" width="38" height="24"><rect width="38" height="24" rx="3" fill="#142FBD"/></svg>' +
                      '</div>' +
                      '<div class="submit__message" style="grid-gap: 10px; padding: 0px 0px; justify-content: center; color: #515151; border: 0px solid rgba(0,0,0,0); border-radius: 0px; background-color: #dae6e6;">' +
                        '<div class="submit__message-text" style="color: #515151; font-weight: normal;">All major credit and debit cards accepted. Paypal also accepted.</div>' +
                      '</div>' +
                    '</div>' +
                  '</div>' +
                '</div>' +
              '</div>' +
            '</div>' +
          '</div>';
      }
      hydrateAllLooxRatings(container);
    }
  };

  window.CPCart = CPCart;

  // Intercept /cart.js, /cart/change.js, /cart/update.js, and /search/suggest.json in fetch & jQuery
  var nativeFetch = window.fetch;
  if (nativeFetch) {
    window.fetch = function(input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      if (url.indexOf('/cart.js') !== -1) {
        return Promise.resolve(new Response(JSON.stringify(CPCart.toShopifyCartJson()), {
          status: 200,
          headers: { 'Content-Type': 'application/json' }
        }));
      }
      if (url.indexOf('/cart/change.js') !== -1 && init && init.body) {
        try {
          var bodyObj = typeof init.body === 'string' ? JSON.parse(init.body) : init.body;
          if (bodyObj && bodyObj.id) {
            CPCart.updateQuantity(bodyObj.id, bodyObj.quantity, bodyObj.properties);
          }
        } catch (e) {}
        return Promise.resolve(new Response(JSON.stringify(CPCart.toShopifyCartJson()), {
          status: 200,
          headers: { 'Content-Type': 'application/json' }
        }));
      }
      return nativeFetch.apply(this, arguments);
    };
  }

  window.handleDigitalDownload = function(checkbox) {
    var u = CPCart.getUpsells();
    u.digitalDownload = !!checkbox.checked;
    CPCart.saveUpsells(u);
    CPCart.renderDrawer();
  };

  window.handleSkipArtwork = function(checkbox) {
    var u = CPCart.getUpsells();
    u.skipArtwork = !!checkbox.checked;
    CPCart.saveUpsells(u);
    CPCart.renderDrawer();
  };

  window.handleGiftCard = function(checkbox) {
    var u = CPCart.getUpsells();
    u.giftCard = !!checkbox.checked;
    CPCart.saveUpsells(u);
    CPCart.renderDrawer();
  };

  /* ========================================================================
     3. HYDRATE PRODUCT PAGE BEFORE CUSTOM ELEMENTS REGISTER
     ======================================================================== */
  function hydrateCurrentProductPage() {
    var route = document.documentElement.getAttribute('data-cp-route');
    if (route !== 'product') return;

    document.body.className = 'sbs-renaissance-faq-focus template-product nothomepage ab-test-review ab-test-add-button ab-test-enable';

    var looxEl = document.getElementById('looxReviews');
    if (looxEl && looxEl.children.length === 0 && window.CP_LOOX_REVIEWS_GRID_HTML) {
      looxEl.innerHTML = window.CP_LOOX_REVIEWS_GRID_HTML;
    }

    var pathParts = window.location.pathname.split('/products/');
    var handle = pathParts[1] ? pathParts[1].split('/')[0].split('?')[0] : 'the-general-custom-pet-canvas';
    var prod = getCatalogProduct(handle);
    if (!prod && window.CP_NATIVE_PRODUCT) {
      prod = window.CP_NATIVE_PRODUCT;
    }
    if (!prod) return;

    window.CP_ACTIVE_PRODUCT = prod;
    window.CP_PDP_OPTION_CONFIG = { mode: 'canvas', step1Key: 'option1', step2Key: 'option2' };
    document.title = prod.title + ' – Crown & Paw';

    var revTotal = prod.review_count || 2936;
    document.querySelectorAll('.product-single__meta .rating-element .review__text').forEach(function(el) {
      el.textContent = 'See what ' + revTotal + ' happy pet parents said about their purchase';
    });
    document.querySelectorAll('.product-single__meta .loox-rating').forEach(function(el) {
      el.setAttribute('data-raters', String(revTotal));
    });

    var sbScript = document.getElementById('step-block-product');
    var prodJsonStr = JSON.stringify({
      id: prod.id,
      title: prod.title,
      handle: prod.handle,
      tags: prod.tags && prod.tags.length ? prod.tags : ['upload with pets name'],
      options: prod.options || ['Size', 'Framing Option'],
      variants: prod.variants || [],
      images: prod.images || [],
      featured_image: prod.featured_image || (prod.images && prod.images[0]) || ''
    });
    if (sbScript) sbScript.textContent = prodJsonStr;
    document.querySelectorAll('.product-json').forEach(function(el) {
      el.textContent = prodJsonStr;
    });

    // Only replace title/description/gallery when viewing a product other than the default "The General"
    if (prod.handle && prod.handle !== 'the-general-custom-pet-canvas') {
      var titleParts = (prod.title || '').split(' - ');
      var mainTitle = titleParts[0] || prod.title;
      var subTitle = titleParts[1] || prod.product_type || 'Custom Pet Portrait';

      document.querySelectorAll('.product__title').forEach(function(el) {
        el.textContent = mainTitle + ' ';
      });
      document.querySelectorAll('.header-wrapper .gap__sec').forEach(function(el) {
        el.textContent = subTitle;
      });
      document.querySelectorAll('.product-single__meta .rating-element .review__text').forEach(function(el) {
        el.textContent = 'See what ' + (prod.review_count || 1420) + ' happy pet parents said about their purchase';
      });
      document.querySelectorAll('.product-single__meta .loox-rating').forEach(function(el) {
        el.setAttribute('data-raters', String(prod.review_count || 1420));
      });

      var fullBodyHtml = '<h2><b>' + escapeHtml(prod.title) + '</b></h2>' + (prod.body_html || '');
      var descEl = document.querySelector('.ReadMore .ReadMore_content');
      if (descEl && prod.body_html) {
        descEl.innerHTML = fullBodyHtml;
      }
      document.querySelectorAll('tab-desc.clive-tab-description .product-single__description, .clive-tab-description .product-single__description').forEach(function(mobDescEl) {
        if (prod.body_html) mobDescEl.innerHTML = fullBodyHtml;
      });

      var prodImages = (prod.images && prod.images.length) ? prod.images : [prod.featured_image || DEFAULT_PORTRAIT_IMG];
      var mainSlideEls = document.querySelectorAll('.main_slider_sec .swiper-wrapper .swiper-slide');
      var thumbSlideEls = document.querySelectorAll('.thumbsSlider_Sec .swiper-wrapper .swiper-slide');
      for (var i = 0; i < mainSlideEls.length; i++) {
        if (i < prodImages.length) {
          var mImg = mainSlideEls[i].querySelector('img');
          if (mImg) {
            mImg.src = prodImages[i];
            mImg.alt = prod.title;
          }
        } else {
          mainSlideEls[i].remove();
        }
      }
      for (var j = 0; j < thumbSlideEls.length; j++) {
        if (j < prodImages.length) {
          var tImg = thumbSlideEls[j].querySelector('img');
          if (tImg) {
            tImg.src = prodImages[j];
            tImg.alt = prod.title;
          }
        } else {
          thumbSlideEls[j].remove();
        }
      }

      // Dynamically adapt Step 1 & Step 2 options for non-Canvas products (Apparel, Mugs, Blankets, Socks)
      var opts = prod.options || ['Size', 'Framing Option'];
      var isStandardCanvas = opts.length === 2 && opts[0] === 'Size' && opts[1] === 'Framing Option';
      if (!isStandardCanvas && prod.variants && prod.variants.length) {
        var opt1Vals = [];
        var opt2Vals = [];
        var opt3Vals = [];
        prod.variants.forEach(function(v) {
          if (v.option1 && opt1Vals.indexOf(v.option1) === -1) opt1Vals.push(v.option1);
          if (v.option2 && opt2Vals.indexOf(v.option2) === -1) opt2Vals.push(v.option2);
          if (v.option3 && opt3Vals.indexOf(v.option3) === -1) opt3Vals.push(v.option3);
        });

        var colorSwatches = {
          'Black': '#1C1C1C',
          'Navy': '#1B2A4A',
          'Sports Grey': '#9E9E9E',
          'Sand': '#D8CAB8',
          'Light Pink': '#F8C8DC',
          'White': '#FFFFFF',
          'Red': '#C62828',
          'Forest Green': '#1B4D3E',
          'Maroon': '#6A1B29',
          'Royal Blue': '#1E40AF'
        };

        var step1Label = opts[0] || 'Size';
        var step1Values = opt1Vals;
        var step2Label = opts[1] || null;
        var step2Values = opt2Vals;

        if (opt3Vals.length > 0) {
          var useOpt1AsStep1 = opt2Vals.length <= 1 && opt1Vals.length > 1;
          var resolvedOpt3 = (opt3Vals.length === 1 && opt3Vals[0] === 'One Size' && prod.handle && prod.handle.indexOf('socks') !== -1) ? ['M', 'L'] : opt3Vals;
          window.CP_PDP_OPTION_CONFIG = {
            mode: 'three-opt',
            step1Key: useOpt1AsStep1 ? 'option1' : 'option2',
            step2Key: 'option3',
            step2Values: resolvedOpt3,
            fixedOption1: opt1Vals[0] || 'Socks'
          };
          step1Label = useOpt1AsStep1 ? (opts[0] || 'Style') : (opts[1] || 'Color');
          step1Values = useOpt1AsStep1 ? opt1Vals : (opt2Vals.length ? opt2Vals : opt1Vals);
          step2Label = opts[2] || 'Size';
          step2Values = resolvedOpt3;
        } else if (opt2Vals.length === 0) {
          window.CP_PDP_OPTION_CONFIG = {
            mode: 'single',
            step1Key: 'option1',
            step2Key: null
          };
        } else {
          window.CP_PDP_OPTION_CONFIG = {
            mode: 'non-canvas',
            step1Key: 'option1',
            step2Key: 'option2'
          };
        }

        var step1Proc = document.querySelector('#step-size .process-name');
        if (step1Proc && step1Label) step1Proc.textContent = step1Label.toUpperCase();

        var sizeStepEl = document.querySelector('.size-step[data-step="Size"]');
        if (sizeStepEl && step1Values.length) {
          var stTitle = sizeStepEl.querySelector('.step-title');
          if (stTitle) stTitle.textContent = 'Choose ' + step1Label;
          var stMain = sizeStepEl.querySelector('.step-main-container');
          if (stMain) {
            stMain.classList.add('cp-noncanvas-grid');
            stMain.innerHTML = step1Values.map(function(val, idx) {
              var hex = colorSwatches[val];
              var swatchHtml = hex ? '<span class="cp-opt-swatch" style="background:' + hex + ';"></span>' : '';
              return (
                '<option-item class="size-part cp-noncanvas-opt' + (idx === 0 ? ' selected' : '') + '" data-v_option="' + escapeHtml(val) + '" data-option="Size">' +
                  swatchHtml +
                  '<div class="size-name">' + escapeHtml(val) + '</div>' +
                  '<div class="size-wrapper" style="display:none;"></div>' +
                '</option-item>'
              );
            }).join('');
          }
        }

        var step2ProcEl = document.getElementById('step-frame');
        var step2ProcName = document.querySelector('#step-frame .process-name');
        var frameStepEl = document.querySelector('.frame-step[data-step="Framing Option"]');
        if (step2Values.length === 0) {
          if (step2ProcEl) step2ProcEl.style.display = 'none';
          if (frameStepEl) frameStepEl.style.display = 'none';
        } else if (frameStepEl) {
          if (step2ProcEl) step2ProcEl.style.display = '';
          if (step2ProcName && step2Label) step2ProcName.textContent = step2Label.toUpperCase();
          var ftTitle = frameStepEl.querySelector('.step-title');
          if (ftTitle) ftTitle.textContent = 'Choose ' + step2Label;
          var isFramePart = frameStepEl.querySelector('.isframe-part');
          if (isFramePart) isFramePart.style.display = 'none';
          frameStepEl.classList.remove('no-frame');
          var ftMain = frameStepEl.querySelector('.step-main-container');
          if (ftMain) {
            ftMain.innerHTML =
              '<div class="step-frame-container-1 cp-noncanvas-grid">' +
                step2Values.map(function(val, idx) {
                  return (
                    '<option-item class="frame-part cp-noncanvas-opt' + (idx === 0 ? ' selected' : '') + '" data-v_option="' + escapeHtml(val) + '" data-option="Framing Option">' +
                      '<div class="frame-name">' + escapeHtml(val) + '</div>' +
                      '<div class="frame-price"></div>' +
                    '</option-item>'
                  );
                }).join('') +
              '</div>';
          }
        }
      }
    }

    hydrateAllLooxRatings();
  }

  /* ========================================================================
     4. DEFINE CROWN & PAW CUSTOM ELEMENTS (<step-block>, <option-item>, etc.)
     ======================================================================== */
  function registerCustomizerElements() {
    if (!customElements.get('before-btn')) {
      customElements.define('before-btn', class extends HTMLElement {
        constructor() {
          super();
          this.addEventListener('click', function(e) {
            e.preventDefault();
            this.dispatchEvent(new Event('before', { bubbles: true }));
          });
        }
      });
    }

    if (!customElements.get('next-btn')) {
      customElements.define('next-btn', class extends HTMLElement {
        constructor() {
          super();
          this.addEventListener('click', function(e) {
            e.preventDefault();
            this.dispatchEvent(new Event('next', { bubbles: true }));
          });
        }
      });
    }

    if (!customElements.get('option-item')) {
      customElements.define('option-item', class extends HTMLElement {
        connectedCallback() {
          this.v_option = this.dataset.v_option;
          this.step = this.dataset.option;
          if (!this._bound) {
            this._bound = true;
            this.addEventListener('click', this.onSelect.bind(this));
          }
        }
        onSelect() {
          var parent = this.closest('[data-step]') || this.parentElement;
          if (parent) {
            parent.querySelectorAll('option-item').forEach(function(sib) {
              sib.classList.remove('selected');
            });
          }
          this.classList.add('selected');
          var self = this;
          setTimeout(function() {
            self.dispatchEvent(new Event('selectopt', { bubbles: true }));
          }, 40);
        }
      });
    }

    if (!customElements.get('extra-add')) {
      customElements.define('extra-add', class extends HTMLElement {
        constructor() {
          super();
          this.addEventListener('click', function(e) {
            e.preventDefault();
            if (this.classList.contains('added')) {
              this.classList.remove('added');
              this.dispatchEvent(new Event('removeextra', { bubbles: true }));
            } else {
              this.classList.add('added');
              this.dispatchEvent(new Event('addextra', { bubbles: true }));
            }
          });
        }
      });
    }

    // Native <tw-gift-message-toggle> Custom Element (from tw-gift-message-toggle.js)
    if (!customElements.get('tw-gift-message-toggle')) {
      customElements.define('tw-gift-message-toggle', class extends HTMLElement {
        constructor() {
          super();
          this.switchButton = this.querySelector('[data-gift-message-switch]');
          this.inner = this.querySelector('.tw-gift-message-toggle__inner');
          this.variantId = this.dataset.variantId;
          this.variantPrice = parseInt(this.dataset.variantPrice, 10) || 500;
          this.isEnabled = false;
          this.savedMessage = '';
          this.boundOnSwitchClick = this.onSwitchClick.bind(this);
          this.boundOnInnerClick = this.onInnerClick.bind(this);
        }
        connectedCallback() {
          if (this.switchButton) {
            this.switchButton.addEventListener('click', this.boundOnSwitchClick);
          }
          if (this.inner) {
            this.inner.addEventListener('click', this.boundOnInnerClick);
          }
        }
        getModal() {
          return document.getElementById('tw-gift-message-modal');
        }
        setEnabled(enabled, options) {
          options = options || {};
          this.isEnabled = enabled;
          this.classList.toggle('is-active', enabled);
          if (this.switchButton) {
            this.switchButton.setAttribute('aria-pressed', enabled ? 'true' : 'false');
          }
          var stepBlock = this.closest('step-block');
          if (stepBlock) {
            stepBlock.giftMessageEnabled = enabled;
            stepBlock.giftMessageVariantId = enabled ? this.variantId : null;
            stepBlock.giftMessagePrice = enabled ? this.variantPrice : 0;
            stepBlock.giftMessageText = enabled ? this.savedMessage : '';
            if (typeof stepBlock.updateSubTotal === 'function') {
              stepBlock.updateSubTotal();
            }
          }
          if (!enabled) {
            this.savedMessage = '';
          }
          if (enabled && !options.skipModal) {
            var modal = this.getModal();
            if (modal && typeof modal.open === 'function') {
              modal.open(this, this.savedMessage);
            }
          }
        }
        clearSavedMessage() {
          this.savedMessage = '';
          this.setEnabled(false, { skipModal: true });
        }
        applySavedMessage(message) {
          var trimmed = (message || '').trim();
          if (trimmed === '') {
            this.clearSavedMessage();
            return;
          }
          this.savedMessage = trimmed;
          this.setEnabled(true, { skipModal: true });
          var stepBlock = this.closest('step-block');
          if (stepBlock) {
            stepBlock.giftMessageText = trimmed;
          }
        }
        onSwitchClick(event) {
          event.preventDefault();
          event.stopPropagation();
          if (this.isEnabled) {
            this.setEnabled(false);
            return;
          }
          this.setEnabled(true);
        }
        onInnerClick(event) {
          if (!this.isEnabled || event.target.closest('[data-gift-message-switch]') || event.target.closest('.extra-add')) return;
          event.preventDefault();
          var modal = this.getModal();
          if (modal && typeof modal.open === 'function') {
            modal.open(this, this.savedMessage);
          }
        }
      });
    }

    // Authentic UploadKit DOM inside <upload-btn-wrapper>
    if (!customElements.get('upload-btn-wrapper')) {
      customElements.define('upload-btn-wrapper', class extends HTMLElement {
        connectedCallback() {
          if (this._initialized) return;
          this._initialized = true;
          this.inputs = { properties: {} };
          this.renderNativeUploader();
        }
        renderNativeUploader() {
          var target = this.querySelector('.uploadkit') || this.querySelector('.upload-button-wrapper') || this;
          var prod = window.CP_ACTIVE_PRODUCT || {};
          var titleLower = (prod.title || '').toLowerCase();
          var petCount = 1;
          if (titleLower.indexOf('2 pet') !== -1 || titleLower.indexOf('two pet') !== -1 || titleLower.indexOf('step brothers') !== -1) petCount = 2;
          else if (titleLower.indexOf('3 pet') !== -1 || titleLower.indexOf('three pet') !== -1) petCount = 3;
          else if (titleLower.indexOf('4 pet') !== -1 || titleLower.indexOf('four pet') !== -1) petCount = 4;

          var uploadersHtml = '';
          for (var p = 1; p <= petCount; p++) {
            var labelText = petCount > 1 ? 'Upload photo #' + p : 'Upload photo';
            var nameLabel = petCount > 1 ? 'Pet #' + p + '\'s Name (Optional)' : 'Pet\'s Name (Optional)';
            uploadersHtml +=
              '<div class="uploadkit-uploader" data-slot="' + p + '">' +
                '<label class="uploadkit-label">' + labelText + '</label>' +
                '<input type="file" accept="image/*" data-cp-file-slot="' + p + '" style="display:none;">' +
                '<button type="button" class="uploadkit-button" data-uploader-name="pet_' + p + '" data-cp-trigger-slot="' + p + '">' +
                  '<svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#3A3A3A" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="17 8 12 3 7 8"></polyline><line x1="12" y1="3" x2="12" y2="15"></line></svg>' +
                  '<span>CHOOSE IMAGE</span>' +
                '</button>' +
                '<div class="uploadkit-attribute-container" id="uk-attr-' + p + '"></div>' +
                '<div class="pet_name">' +
                  '<label>' + nameLabel + '</label>' +
                  '<input type="text" name="properties[_pet_' + p + '_petName]" placeholder="Enter Pet\'s Name" value="">' +
                '</div>' +
              '</div>';
          }

          target.innerHTML =
            uploadersHtml +
            '<div class="hsi_input">' +
              '<label>Notes for our Artists (Optional)</label>' +
              '<input type="text" name="properties[_artist_notes]" placeholder="Any special requests?" value="">' +
            '</div>';

          var self = this;

          target.querySelectorAll('button.uploadkit-button').forEach(function(btn) {
            btn.addEventListener('click', function(ev) {
              ev.preventDefault();
              var slot = btn.getAttribute('data-cp-trigger-slot');
              var fileInp = target.querySelector('[data-cp-file-slot="' + slot + '"]');
              if (fileInp) fileInp.click();
            });
          });

          target.querySelectorAll('[data-cp-file-slot]').forEach(function(input) {
            input.addEventListener('change', function(ev) {
              var slot = input.getAttribute('data-cp-file-slot');
              var file = ev.target.files && ev.target.files[0];
              if (!file) return;
              var reader = new FileReader();
              reader.onload = function(e) {
                self.setSlotPhoto(slot, e.target.result, file.name);
              };
              reader.readAsDataURL(file);
            });
          });
        }
        setSlotPhoto(slot, dataUrl, fileName) {
          this.inputs.properties['_pet_' + slot + '_photo_data'] = dataUrl;
          this.inputs.properties['_pet_' + slot + '_photo_name'] = fileName;
          var btn = this.querySelector('button.uploadkit-button[data-cp-trigger-slot="' + slot + '"]');
          var attrBox = this.querySelector('#uk-attr-' + slot);
          if (btn) btn.style.display = 'none';
          if (attrBox) {
            attrBox.classList.add('has-file');
            attrBox.innerHTML =
              '<img src="' + escapeHtml(dataUrl) + '" alt="' + escapeHtml(fileName) + '">' +
              '<div class="uk-file-info">' +
                '<div class="uk-file-name">' + escapeHtml(fileName) + '</div>' +
              '</div>' +
              '<button type="button" class="uk-file-remove" data-uk-remove="' + slot + '">Remove</button>' +
              '<input type="hidden" name="properties[_pet_' + slot + ']" value="' + escapeHtml(fileName) + '">';
            var self = this;
            attrBox.querySelector('[data-uk-remove]')?.addEventListener('click', function(e) {
              e.preventDefault();
              self.clearSlotPhoto(slot);
            });
          }
        }
        clearSlotPhoto(slot) {
          delete this.inputs.properties['_pet_' + slot + '_photo_data'];
          delete this.inputs.properties['_pet_' + slot + '_photo_name'];
          var btn = this.querySelector('button.uploadkit-button[data-cp-trigger-slot="' + slot + '"]');
          var attrBox = this.querySelector('#uk-attr-' + slot);
          if (btn) btn.style.display = 'flex';
          if (attrBox) {
            attrBox.classList.remove('has-file');
            attrBox.innerHTML = '';
          }
        }
        hasUploadedPhoto() {
          var firstAttr = this.querySelector('.uploadkit-attribute-container');
          return !!(this.inputs.properties._pet_1_photo_data || this.inputs.properties._upload_later || (firstAttr && firstAttr.innerHTML.trim() !== ''));
        }
      });
    }

    if (!customElements.get('step-block')) {
      customElements.define('step-block', class extends HTMLElement {
        connectedCallback() {
          if (this._initialized) return;
          this._initialized = true;
          StepBlockInstance = this;

          var prodEl = document.getElementById('step-block-product');
          this.product = prodEl ? JSON.parse(prodEl.textContent) : (window.CP_ACTIVE_PRODUCT || getCatalogProduct('the-general-custom-pet-canvas'));
          this.optConfig = window.CP_PDP_OPTION_CONFIG || { mode: 'canvas', step1Key: 'option1', step2Key: 'option2' };
          this.steps = ['size', 'framing option', 'upload', 'extra'];

          var defaultVariant = (this.optConfig.mode === 'canvas')
            ? ((this.product.variants && this.product.variants[1]) || (this.product.variants && this.product.variants[0]))
            : (this.product.variants && this.product.variants[0]);
          this.cur_variant = defaultVariant || {
            id: 40123609022550,
            option1: '8" x 10"',
            option2: 'Unframed',
            options: ['8" x 10"', 'Unframed'],
            price: 6995,
            compare_at_price: 7995
          };

          if (this.optConfig.mode === 'single') {
            this.cur_options = [this.cur_variant.option1 || 'One Size', null];
          } else if (this.optConfig.mode === 'three-opt') {
            var s1k = this.optConfig.step1Key || 'option2';
            this.cur_options = [this.cur_variant[s1k] || 'Custom', (this.optConfig.step2Values && this.optConfig.step2Values[0]) || this.cur_variant.option3 || 'M'];
          } else {
            this.cur_options = [this.cur_variant.option1 || '8" x 10"', this.cur_variant.option2 || 'Unframed'];
          }

          this.extras = [];
          this.giftMessageEnabled = false;
          this.giftMessageText = '';
          this.giftMessagePrice = 500;

          this.beforeBtn = this.querySelector('before-btn');
          this.nextBtn = this.querySelector('next-btn');
          this.addCartBtn = this.querySelector('.atc-btn');
          this.uploadWrap = this.querySelector('upload-btn-wrapper');

          var self = this;
          this.querySelectorAll('[data-step="Size"] option-item').forEach(function(item) {
            item.classList.toggle('selected', item.dataset.v_option === self.cur_options[0]);
          });
          this.querySelectorAll('[data-step="Framing Option"] option-item').forEach(function(item) {
            item.classList.toggle('selected', item.dataset.v_option === self.cur_options[1]);
          });

          if (this.optConfig.mode === 'canvas') {
            var frameStepEl = this.querySelector('.frame-step');
            if (frameStepEl) {
              // Show Frame tab by default so 4 frame options are visible on Step 2
              frameStepEl.classList.remove('no-frame');
              var fTab = this.querySelector('[data-type="frame"]');
              var nfTab = this.querySelector('[data-type="no-frame"]');
              if (fTab) fTab.classList.add('selected');
              if (nfTab) nfTab.classList.remove('selected');
            }
          }

          this.bindEvents();
          this.setStep(0, false);
          this.updateSubTotal();
        }
        bindEvents() {
          var self = this;
          this.addEventListener('selectopt', function(ev) {
            var optVal = ev.target.dataset.v_option;
            var optStep = ev.target.dataset.option;
            if (optStep === 'Size') {
              self.cur_options[0] = optVal;
              if (self.optConfig.mode === 'canvas' && optVal === 'Digital Download') {
                self.cur_options[1] = 'Unframed';
              }
            } else if (optStep === 'Framing Option') {
              self.cur_options[1] = optVal;
            }
            self.syncVariantFromOptions();
          });

          this.addEventListener('before', function() {
            var idx = parseInt(self.dataset.index || '0', 10);
            var prev = Math.max(0, idx - 1);
            if ((self.optConfig.mode === 'single' || self.cur_options[0] === 'Digital Download') && prev === 1) {
              prev = 0;
            }
            self.setStep(prev, true);
          });

          this.addEventListener('next', function() {
            var idx = parseInt(self.dataset.index || '0', 10);
            var curName = self.steps[idx];
            if (curName === 'upload' && self.uploadWrap && !self.uploadWrap.hasUploadedPhoto()) {
              var mb = document.querySelector('.mb_container');
              if (mb) {
                mb.style.display = 'block';
                return;
              }
            }
            var next = Math.min(self.steps.length - 1, idx + 1);
            if ((self.optConfig.mode === 'single' || self.cur_options[0] === 'Digital Download') && next === 1) {
              next = 2;
            }
            self.setStep(next, true);
          });

          this.querySelectorAll('.step-processes .step-process').forEach(function(proc, sIdx) {
            proc.addEventListener('click', function() {
              if (self.optConfig.mode === 'single' && sIdx === 1) return;
              self.setStep(sIdx, false);
            });
          });

          this.querySelectorAll('.frame-tab').forEach(function(tab) {
            tab.addEventListener('click', function() {
              if (self.optConfig.mode !== 'canvas') return;
              var type = tab.getAttribute('data-type');
              var frameStep = self.querySelector('.frame-step');
              self.querySelectorAll('.frame-tab').forEach(function(t) {
                t.classList.toggle('selected', t === tab);
              });
              if (type === 'no-frame') {
                if (frameStep) frameStep.classList.add('no-frame');
                self.cur_options[1] = 'Unframed';
                self.querySelectorAll('[data-step="Framing Option"] option-item').forEach(function(it) {
                  it.classList.toggle('selected', it.dataset.v_option === 'Unframed');
                });
              } else {
                if (frameStep) frameStep.classList.remove('no-frame');
                if (self.cur_options[1] === 'Unframed') {
                  self.cur_options[1] = 'Black';
                  self.querySelectorAll('[data-step="Framing Option"] option-item').forEach(function(it) {
                    it.classList.toggle('selected', it.dataset.v_option === 'Black');
                  });
                }
              }
              self.syncVariantFromOptions();
            });
          });

          this.addEventListener('addextra', function(ev) {
            var vid = ev.target.dataset.v_id;
            var price = parseInt(ev.target.dataset.v_price || '0', 10);
            var title = ev.target.closest('.extra-variant')?.querySelector('.extra-title')?.textContent?.trim() || 'Extra Add-on';
            if (!self.extras.some(function(x) { return x.id === vid; })) {
              self.extras.push({ id: vid, price: price, title: title });
            }
            self.updateSubTotal();
          });

          this.addEventListener('removeextra', function(ev) {
            var vid = ev.target.dataset.v_id;
            self.extras = self.extras.filter(function(x) { return x.id !== vid; });
            self.updateSubTotal();
          });

          if (this.addCartBtn) {
            this.addCartBtn.addEventListener('click', function(e) {
              e.preventDefault();
              self.handleAddToCart();
            });
          }
        }
        syncVariantFromOptions() {
          var self = this;
          var variants = this.product.variants || [];
          var k1 = this.optConfig.step1Key || 'option1';
          var k2 = this.optConfig.step2Key;
          var matched = null;
          if (k2) {
            matched = variants.find(function(v) {
              return v[k1] === self.cur_options[0] && v[k2] === self.cur_options[1];
            });
          }
          if (!matched) {
            matched = variants.find(function(v) {
              return v[k1] === self.cur_options[0];
            }) || variants[0];
          }

          if (matched) {
            this.cur_variant = matched;
          }
          this.updatePremiumBadges();
          this.updateSubTotal();
        }
        updatePremiumBadges() {
          var self = this;
          var variants = this.product.variants || [];
          var curPrice = parseInt(this.cur_variant.price, 10) || 3995;
          var k1 = this.optConfig.step1Key || 'option1';
          var k2 = this.optConfig.step2Key;

          this.querySelectorAll('[data-step="Size"] option-item').forEach(function(item) {
            var sizeVal = item.dataset.v_option;
            var v = (k2 && variants.find(function(x) { return x[k1] === sizeVal && x[k2] === self.cur_options[1]; })) ||
                    variants.find(function(x) { return x[k1] === sizeVal; });
            var wrap = item.querySelector('.size-wrapper');
            if (wrap && v) {
              var delta = (parseInt(v.price, 10) || 0) - curPrice;
              wrap.innerHTML = delta > 0 ? '<div class="add-price">+' + formatMoney(delta) + '</div>' : '';
            }
          });

          if (k2) {
            this.querySelectorAll('[data-step="Framing Option"] option-item').forEach(function(item) {
              var frameVal = item.dataset.v_option;
              var v = variants.find(function(x) { return x[k1] === self.cur_options[0] && x[k2] === frameVal; });
              var priceEl = item.querySelector('.frame-price');
              if (priceEl && v) {
                var delta = (parseInt(v.price, 10) || 0) - curPrice;
                priceEl.innerHTML = delta > 0 ? '+' + formatMoney(delta) : '';
              }
            });
          }
        }
        setStep(index, scroll) {
          index = Math.max(0, Math.min(this.steps.length - 1, parseInt(index, 10) || 0));
          if (this.optConfig.mode === 'single' && index === 1) {
            index = 2;
          }
          this.dataset.index = String(index);
          this.dataset.current = this.steps[index];

          if (this.optConfig.mode === 'canvas' && index === 1 && this.cur_options[0] !== 'Digital Download') {
            var frameStepEl = this.querySelector('.frame-step');
            if (frameStepEl) frameStepEl.classList.remove('no-frame');
          }

          var procs = this.querySelectorAll('.step-processes .step-process');
          procs.forEach(function(proc, i) {
            proc.classList.remove('active', 'current');
            if (i === index) proc.classList.add('current');
            else if (i < index) proc.classList.add('active');
          });

          this.updatePremiumBadges();
          this.updateSubTotal();

          if (scroll && window.innerWidth < 1024) {
            var rect = this.getBoundingClientRect();
            window.scrollTo({ top: window.scrollY + rect.top - 70, behavior: 'smooth' });
          }
        }
        updateSubTotal() {
          var basePrice = parseInt(this.cur_variant.price, 10) || 3995;
          var baseCompare = parseInt(this.cur_variant.compare_at_price, 10) || (basePrice + 4000);
          var extrasTotal = this.extras.reduce(function(s, x) { return s + (parseInt(x.price, 10) || 0); }, 0);
          var giftTotal = this.giftMessageEnabled ? (this.giftMessagePrice || 500) : 0;

          var totalCents = basePrice + extrasTotal + giftTotal;
          var wasCents = Math.max(baseCompare, basePrice) + extrasTotal + giftTotal;
          var saveCents = Math.max(0, wasCents - totalCents);

          var subMoney = this.querySelector('.subtotal .money');
          if (subMoney) subMoney.innerHTML = '<span class="money">' + formatMoney(totalCents) + '</span>';

          var cmpHolder = this.querySelector('[data-compare-holder]');
          var cmpMoney = this.querySelector('[data-compare-money]');
          if (cmpHolder && cmpMoney) {
            if (saveCents > 0) {
              cmpHolder.style.display = '';
              cmpMoney.innerHTML = '<span class="money">' + formatMoney(wasCents) + '</span>';
            } else {
              cmpHolder.style.display = 'none';
            }
          }

          var saveHolder = this.querySelector('[data-save-holder]');
          var saveMoney = this.querySelector('[data-save-money]');
          if (saveHolder && saveMoney) {
            if (saveCents > 0) {
              saveHolder.style.display = '';
              saveMoney.innerHTML = '<span class="money">' + formatMoney(saveCents) + '</span>';
            } else {
              saveHolder.style.display = 'none';
            }
          }

          var fsEl = this.querySelector('.step-freeshipping');
          if (fsEl) {
            var threshold = 7500;
            if (totalCents < threshold) {
              fsEl.innerHTML = '<p>You\'re only <span class="money">' + formatMoney(threshold - totalCents) + '</span> away from <strong>FREE SHIPPING</strong></p>';
            } else {
              fsEl.innerHTML = '<p>Congrats! You\'ve earned <strong>FREE SHIPPING</strong></p>';
            }
          }
        }
        handleAddToCart() {
          var props = Object.assign({}, this.uploadWrap ? this.uploadWrap.inputs.properties : {});
          if (this.uploadWrap) {
            this.uploadWrap.querySelectorAll('input[type="text"], input[type="hidden"]').forEach(function(inp) {
              if (inp.name && inp.value) {
                var key = inp.name.replace('properties[', '').replace(']', '');
                props[key] = inp.value;
              }
            });
          }
          if (this.giftMessageEnabled && this.giftMessageText) {
            props['_Gift Message'] = this.giftMessageText;
          }

          var u = CPCart.getUpsells();
          var upsellChanged = false;
          var nonDrawerExtras = [];
          this.extras.forEach(function(ex) {
            var tLower = (ex.title || '').toLowerCase();
            var pVal = parseInt(ex.price, 10) || 0;
            if (tLower.indexOf('sooner') !== -1 || tLower.indexOf('skip') !== -1 || pVal === 1500) {
              u.skipArtwork = true;
              upsellChanged = true;
            } else if (tLower.indexOf('digital') !== -1 || pVal === 1000) {
              u.digitalDownload = true;
              upsellChanged = true;
            } else {
              nonDrawerExtras.push(ex);
            }
          });
          if (upsellChanged) {
            CPCart.saveUpsells(u);
          }

          if (nonDrawerExtras.length > 0) {
            props['_Extras'] = nonDrawerExtras.map(function(e) { return e.title; }).join(', ');
          }

          var basePrice = parseInt(this.cur_variant.price, 10) || 3995;
          var nonDrawerExtrasTotal = nonDrawerExtras.reduce(function(s, x) { return s + (parseInt(x.price, 10) || 0); }, 0);
          var giftTotal = (this.giftMessageEnabled && this.giftMessageText) ? (this.giftMessagePrice || 500) : 0;

          var opt1Out = this.cur_variant.option1 || this.cur_options[0] || '8" x 10"';
          var opt2Out = this.optConfig.mode === 'single' ? '' : (this.cur_variant.option2 || this.cur_options[1] || '');
          var opt3Out = this.optConfig.mode === 'three-opt' ? (this.cur_variant.option3 || this.cur_options[1] || '') : '';
          var optsLabel = (this.product.options || ['Size', 'Framing Option']).join(' / ');

          CPCart.addItem({
            id: this.cur_variant.id || Date.now(),
            handle: this.product.handle || 'the-general-custom-pet-canvas',
            title: this.product.title || 'The General - Custom Pet Canvas',
            productType: this.product.product_type || 'Custom Pet Portrait',
            optionsLabel: optsLabel,
            image: this.product.featured_image || (this.product.images && this.product.images[0]) || DEFAULT_PORTRAIT_IMG,
            option1: opt1Out,
            option2: opt2Out,
            option3: opt3Out,
            price: basePrice + nonDrawerExtrasTotal,
            hasGiftFee: giftTotal > 0,
            giftFee: giftTotal,
            quantity: 1,
            properties: props
          });

          window.open_cart_drawer();
        }
      });
    }
  }

  var StepBlockInstance = null;

  /* ========================================================================
     5. NATIVE .nikita_product_card RENDERER & COLLECTION / SEARCH HYDRATION
     ======================================================================== */
  function renderNikitaProductCard(p) {
    var rawImg = p.featured_image || (p.images && p.images[0]) || DEFAULT_PORTRAIT_IMG;
    var img1 = rawImg.replace('_500x.', '_375x.');
    var priceCents = parseInt(p.price, 10) || 3995;
    var compareCents = parseInt(p.compare_at_price, 10) || 7995;
    var saveCents = Math.max(0, compareCents - priceCents);
    var titleParts = (p.title || '').split(' - ');
    var mainTitle = titleParts[0] || p.title;
    var subTitle = titleParts.length > 1 ? titleParts[1] : '';
    var revCount = p.review_count || 720;

    var compareHtml = saveCents > 0
      ? '<div class="card__compare__price">' +
          '<div class="compare__price_money"><span class="money">' + formatMoney(compareCents) + '</span></div>' +
          '<div class="card__discount">Save &nbsp;<span class="money">' + formatMoneyShort(saveCents) + '</span></div>' +
        '</div>'
      : '';

    var subtitleHtml = subTitle ? '<p class="card__subtitle">' + escapeHtml(subTitle) + '</p>' : '';

    return (
      '<div class="nikita_product_card" handle="' + escapeHtml(p.handle) + '">' +
        '<a href="/products/' + escapeHtml(p.handle) + '" class="card__link">' +
          '<div class="card__media">' +
            '<img src="' + escapeHtml(img1) + '" data-src="' + escapeHtml(img1) + '" alt="' + escapeHtml(p.title) + '" class="card__image lazyload" onerror="this.onerror=null;this.src=\'' + DEFAULT_PORTRAIT_IMG + '\';">' +
          '</div>' +
          '<div class="card__content">' +
            '<div class="card__review">' +
              '<div class="loox-rating" data-id="' + escapeHtml(p.id || 3958383771734) + '" data-rating="5" data-raters="' + revCount + '">' + buildLooxStarsHtml(revCount, true) + '</div>' +
            '</div>' +
            '<h6 class="card__title">' + escapeHtml(mainTitle) + '</h6>' +
            subtitleHtml +
            '<div class="card__prices">' +
              compareHtml +
              '<div class="card__sale__price">From&nbsp; <div class="sale__price_money"><span class="money">' + formatMoney(priceCents) + '</span></div></div>' +
            '</div>' +
          '</div>' +
        '</a>' +
      '</div>'
    );
  }

  function hydrateCurrentCollectionPage() {
    var route = document.documentElement.getAttribute('data-cp-route');
    if (route !== 'collection') return;

    document.body.className = 'best-seller-winner template-collection nothomepage';

    var cat = window.CP_CATALOG;
    if (!cat || !cat.collections) return;

    var pathParts = window.location.pathname.split('/collections/');
    var collHandle = pathParts[1] ? pathParts[1].split('/')[0].split('?')[0] : 'best-sellers';
    if (!collHandle) collHandle = 'best-sellers';

    var collectionAliases = {
      'modern-pet-portraits': 'modern-pet-portraits-collection',
      'custom-pet-apparel': 'apparel',
      'custom-clothing': 'apparel',
      'design-your-own-clothing': 'apparel',
      'shop-all': 'all',
      'blankets': 'design-your-own-blanket',
      'handmade-replica-gifts': 'custom-pet-replica'
    };
    var resolvedCollKey = collectionAliases[collHandle] || collHandle;

    var fallbackCollections = {
      'dogs': {
        title: 'Dog Portraits',
        description: 'The perfect gift for a dog lover or pet owner: Pet art from your photos! Your design will be ready to review and approve within 1-2 days of placing your order.',
        products: (cat.collections['male'] && cat.collections['male'].products) || (cat.collections['best-sellers'] && cat.collections['best-sellers'].products) || []
      },
      'cats': {
        title: 'Cat Portraits',
        description: 'Immortalize your feline royalty on museum-quality canvas or framed art! Free preview ready to review within 1-2 days.',
        products: (cat.collections['female'] && cat.collections['female'].products) || (cat.collections['best-sellers'] && cat.collections['best-sellers'].products) || []
      },
      'new-releases': {
        title: 'New Releases',
        description: 'Explore our latest custom pet portrait costumes, modern art styles, and seasonal favorites.',
        products: (cat.collections['best-sellers'] && cat.collections['best-sellers'].products) || []
      },
      'shop-all': {
        title: 'Shop All',
        description: 'Every single product in one place! Have fun browsing the complete Crown & Paw range, from renaissance portraits to custom pet socks.',
        products: Object.keys(cat.productsByHandle || {})
      },
      'all': {
        title: 'Shop All',
        description: 'Every single product in one place! Have fun browsing the complete Crown & Paw range, from renaissance portraits to custom pet socks.',
        products: Object.keys(cat.productsByHandle || {})
      },
      'apparel': {
        title: 'Custom Pet Apparel for Humans',
        description: 'Custom pet hoodies and custom pet t-shirts, printed with our signature renaissance style pet portraits, or choose from modern and cartoon style custom pet apparel.',
        products: (cat.collections['apparel'] && cat.collections['apparel'].products) || []
      },
      'modern-pet-portraits': {
        title: 'Modern Pet Portraits',
        description: 'Minimalist, watercolor, line art, and contemporary custom pet portraits designed by real digital artists.',
        products: (cat.collections['modern-pet-portraits-collection'] && cat.collections['modern-pet-portraits-collection'].products) || []
      },
      'custom-pet-apparel': {
        title: 'Custom Pet Apparel for Humans',
        description: 'Custom pet hoodies and custom pet t-shirts, printed with our signature renaissance style pet portraits, or choose from modern and cartoon style custom pet apparel.',
        products: (cat.collections['apparel'] && cat.collections['apparel'].products) || []
      }
    };

    var collObj = Object.assign({}, cat.collections[collHandle] || fallbackCollections[collHandle] || cat.collections[resolvedCollKey] || fallbackCollections[resolvedCollKey] || {
      title: collHandle.replace(/-/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); }),
      description: 'The perfect gift for a dog lover or pet owner: Pet art from your photos! Your design will be ready to review and approve within 1-2 days of placing your order.',
      products: (cat.collections['best-sellers'] && cat.collections['best-sellers'].products) || []
    });
    if (collHandle === 'apparel' || resolvedCollKey === 'apparel') {
      collObj.title = 'Custom Pet Apparel for Humans';
    } else if (collHandle === 'shop-all' || collHandle === 'all') {
      collObj.title = 'Shop All';
    }

    var collectionMetaCounts = {
      'best-sellers': { count: 41, pages: 3 },
      'shop-all': { count: 1326, pages: 67 },
      'all': { count: 1326, pages: 67 },
      'apparel': { count: 135, pages: 7 },
      'custom-pet-apparel': { count: 135, pages: 7 }
    };
    var metaCfg = collectionMetaCounts[collHandle] || collectionMetaCounts[resolvedCollKey] || null;

    document.title = collObj.title + ' – Crown & Paw';

    // Update Banner & Sidebar Headings while preserving 100% of native DOM
    var bannerTitle = document.querySelector('.collection_banner_v2 .collection_heading');
    if (bannerTitle) bannerTitle.textContent = collObj.title;
    var bannerDesc = document.querySelector('.collection_banner_v2 .collection_description p');
    if (bannerDesc && collObj.description) bannerDesc.textContent = collObj.description;

    var indicatorLink = document.querySelector('.collection_filter_side_bar .col__indicator a:last-child');
    if (indicatorLink) {
      indicatorLink.textContent = collObj.title;
      indicatorLink.setAttribute('href', '/collections/' + collHandle);
    }
    var sideLabel = document.querySelector('.collection_filter_side_bar h4.collection__label');
    if (sideLabel) sideLabel.textContent = collObj.title;

    // Highlight active collection radio button in left sidebar (keep accordions collapsed by default like REF)
    document.querySelectorAll('.collection__navigation__panel a.col__sublink').forEach(function(a) {
      var href = (a.getAttribute('href') || '').replace(/^https?:\/\/crownandpaw\.com/i, '');
      a.setAttribute('href', href);
      var radio = a.querySelector('.radio__button');
      var isMatch = (collHandle !== 'shop-all' && collHandle !== 'all') && ((href === '/collections/' + collHandle) || (href === '/collections/' + resolvedCollKey));
      if (radio) radio.classList.toggle('active', isMatch);
    });

    // Apply per-collection section visibility & banner/description overrides matching REF
    var countdownSec = document.getElementById('shopify-section-template--18750069866582__countdown_timer_yKd3xm') || document.querySelector('[id*="__countdown_timer_"]');
    var bannerSec = document.querySelector('.collection_banner_v2');
    var bannerMainWrap = document.querySelector('.collection_banner_v2 .main_wrapper');
    var bannerContentInner = document.querySelector('.collection_banner_v2 .content_inner');
    var bannerImgInner = document.querySelector('.collection_banner_v2 .image_inner');
    var bannerImgEl = document.querySelector('.collection_banner_v2 .image_inner img');
    var descSec = document.querySelector('.collection_desc_v2');
    var descImgEl = document.querySelector('.collection_desc_v2 .image_inner img');

    if (collHandle === 'shop-all' || collHandle === 'all') {
      if (countdownSec) countdownSec.style.display = 'none';
      if (bannerImgInner) bannerImgInner.style.setProperty('display', 'none', 'important');
      if (bannerMainWrap) bannerMainWrap.style.gridTemplateColumns = '1fr';
      if (bannerContentInner) bannerContentInner.style.margin = '0 auto';
      if (descSec) descSec.style.display = 'none';
    } else if (collHandle === 'apparel' || resolvedCollKey === 'apparel') {
      if (countdownSec) countdownSec.style.display = 'none';
      if (bannerSec) bannerSec.setAttribute('data-hide-mobile-img', 'true');
      if (bannerImgEl) {
        var appBannerUrl = '//crownandpaw.com/cdn/shop/collections/Hoodie_Collection_bd1a2292-0962-45d7-8822-277a3a8bd552_500x.jpg?v=1652202190';
        bannerImgEl.src = appBannerUrl;
        bannerImgEl.setAttribute('data-src', appBannerUrl);
      }
      if (descImgEl) {
        var appDescUrl = '//crownandpaw.com/cdn/shop/collections/1_40c02837-5016-4f08-9e4b-d112d8b8c04d_500x.jpg?v=1739909270';
        descImgEl.src = appDescUrl;
        descImgEl.setAttribute('data-src', appDescUrl);
      }
    }

    var baseHandles = collObj.products && collObj.products.length ? collObj.products : Object.keys(cat.productsByHandle);
    var baseProducts = baseHandles.map(function(h) { return cat.productsByHandle[h]; }).filter(Boolean);

    if (collHandle !== 'best-sellers' && collHandle !== 'shop-all' && collHandle !== 'all' && collHandle !== 'apparel' && resolvedCollKey !== 'apparel' && baseProducts.length > 0) {
      var bannerImgs = document.querySelectorAll('.collection_banner_v2 .image_inner img, .collection_desc_v2 .image_inner img');
      bannerImgs.forEach(function(bImg, idx) {
        var sampleProd = baseProducts[idx % baseProducts.length];
        if (sampleProd && sampleProd.featured_image) {
          bImg.src = sampleProd.featured_image;
          bImg.setAttribute('data-src', sampleProd.featured_image);
          bImg.alt = collObj.title;
        }
      });
    }

    function buildCollectionPaginationHtml(totalPages) {
      var pages = totalPages || (metaCfg ? metaCfg.pages : 3);
      return (
        '<div class="collection__pagination">' +
          '<link href="//crownandpaw.com/cdn/shop/t/458/assets/pagination-v2.css?v=10114142421478850311763123411" rel="stylesheet" type="text/css" media="all" />' +
          '<ul class="pagination-v2">' +
            '<li><a href="" class="pagination-btn-v2 btn-prev-v2 "><svg class="caret" width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 0.401455C0 0.296631 0.0375226 0.191808 0.117258 0.115572C0.272039 -0.0368989 0.520625 -0.0369001 0.675406 0.120336L5.42201 5.03276L10.3281 0.115572C10.4829 -0.0416637 10.7315 -0.0369001 10.8862 0.120336C11.041 0.277571 11.0363 0.530103 10.8815 0.687338L5.68936 5.88565C5.61431 5.96188 5.51582 6 5.40794 6C5.30006 6 5.20157 5.95712 5.13121 5.88088L0.112567 0.682573C0.0375223 0.606338 0 0.501514 0 0.401455Z" fill="black"/></svg></a></li>' +
            '<li class="pagination__text">Page 1 of ' + pages + '</li>' +
            '<li><a href="/collections/' + escapeHtml(collHandle) + '?page=2" class="pagination-btn-v2 btn-next-v2 pagination__active_link"><svg class="caret" width="11" height="6" viewBox="0 0 11 6" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M0 0.401455C0 0.296631 0.0375226 0.191808 0.117258 0.115572C0.272039 -0.0368989 0.520625 -0.0369001 0.675406 0.120336L5.42201 5.03276L10.3281 0.115572C10.4829 -0.0416637 10.7315 -0.0369001 10.8862 0.120336C11.041 0.277571 11.0363 0.530103 10.8815 0.687338L5.68936 5.88565C5.61431 5.96188 5.51582 6 5.40794 6C5.30006 6 5.20157 5.95712 5.13121 5.88088L0.112567 0.682573C0.0375223 0.606338 0 0.501514 0 0.401455Z" fill="black"/></svg></a></li>' +
          '</ul>' +
        '</div>'
      );
    }

    function renderNativeCollectionDom() {
      var activeFilters = [];
      document.querySelectorAll('.new__filter__drawer .filter__value.active').forEach(function(el) {
        var dv = el.getAttribute('data-value') || '';
        if (dv) activeFilters.push(dv);
      });

      var sortSelect = document.getElementById('collection_sort');
      var sortVal = sortSelect ? sortSelect.value : 'Sort By';

      var filtered = baseProducts.filter(function(p) {
        if (activeFilters.length === 0) return true;
        var tagsLower = (p.tags || []).map(function(t) { return String(t).toLowerCase(); });
        var textBlob = ((p.title || '') + ' ' + (p.product_type || '') + ' ' + tagsLower.join(' ')).toLowerCase();
        return activeFilters.every(function(f) {
          var parts = f.split('=');
          var rawTag = (parts[1] || parts[0] || '').toLowerCase();
          var val = rawTag.replace(/-/g, ' ');
          if (!val) return true;
          if (tagsLower.indexOf(rawTag) !== -1 || tagsLower.indexOf(val) !== -1) return true;
          if (val === 'male') return textBlob.indexOf('king') !== -1 || textBlob.indexOf('general') !== -1 || textBlob.indexOf('admiral') !== -1 || textBlob.indexOf('lord') !== -1 || textBlob.indexOf('sir') !== -1 || textBlob.indexOf('duke') !== -1 || textBlob.indexOf('prince') !== -1 || textBlob.indexOf('count') !== -1 || textBlob.indexOf('brother') !== -1;
          if (val === 'female') return textBlob.indexOf('queen') !== -1 || textBlob.indexOf('princess') !== -1 || textBlob.indexOf('lady') !== -1 || textBlob.indexOf('duchess') !== -1 || textBlob.indexOf('dame') !== -1 || textBlob.indexOf('girl') !== -1 || textBlob.indexOf('sister') !== -1 || textBlob.indexOf('rose') !== -1;
          if (val === 'one pet') return textBlob.indexOf('two') === -1 && textBlob.indexOf('three') === -1 && textBlob.indexOf('four') === -1;
          return textBlob.indexOf(val) !== -1;
        });
      });

      if (sortVal === 'title-ascending') {
        filtered.sort(function(a, b) { return a.title.localeCompare(b.title); });
      } else if (sortVal === 'title-descending') {
        filtered.sort(function(a, b) { return b.title.localeCompare(a.title); });
      } else if (sortVal === 'price-ascending') {
        filtered.sort(function(a, b) { return (a.price || 3995) - (b.price || 3995); });
      } else if (sortVal === 'price-descending') {
        filtered.sort(function(a, b) { return (b.price || 3995) - (a.price || 3995); });
      } else if (sortVal === 'created-descending') {
        filtered = filtered.slice().reverse();
      }

      var isDefaultUnfiltered = activeFilters.length === 0 && (sortVal === 'Sort By' || sortVal === 'best-selling');
      var displayCount = (isDefaultUnfiltered && metaCfg) ? metaCfg.count : filtered.length;
      var displayPages = (isDefaultUnfiltered && metaCfg) ? metaCfg.pages : Math.max(1, Math.ceil(filtered.length / 20));

      var totalCountEl = document.getElementById('total__count');
      if (totalCountEl) totalCountEl.textContent = String(displayCount);
      document.querySelectorAll('[role="filter__count"]').forEach(function(el) {
        el.textContent = String(displayCount);
      });

      var bestsellerBox = document.querySelector('.collection_grid_v2 .bestseller_box');
      var bestsellerInner = document.querySelector('.collection_grid_v2 .bestseller_inner_wrapper');
      var featuredBox = document.querySelector('.collection_grid_v2 .featured_box');

      if (bestsellerBox && bestsellerInner && featuredBox) {
        if (isDefaultUnfiltered && filtered.length > 4) {
          bestsellerBox.style.display = '';
          bestsellerInner.innerHTML = filtered.slice(0, 4).map(renderNikitaProductCard).join('');
          var gridSlice = filtered.slice(4, 20);
          while (gridSlice.length < 16 && filtered.length > 0) {
            gridSlice.push(filtered[gridSlice.length % filtered.length]);
          }
          featuredBox.innerHTML = gridSlice.slice(0, 16).map(renderNikitaProductCard).join('') + buildCollectionPaginationHtml(displayPages);
        } else {
          bestsellerBox.style.display = 'none';
          featuredBox.innerHTML = filtered.length > 0
            ? filtered.slice(0, 16).map(renderNikitaProductCard).join('') + buildCollectionPaginationHtml(displayPages)
            : '<h6 class="no_results">No matching portraits found</h6>';
        }
      }
      hydrateAllLooxRatings();
    }

    // Override collection inline functions so native UI controls operate client-side without 404 AJAX
    window.open_filter_drawer = function() {
      var drawer = document.getElementById('collection__filter__drawer');
      if (!drawer) return;
      drawer.style.display = 'block';
      setTimeout(function() { drawer.classList.add('open'); }, 20);
    };
    window.close_filter_drawer = function() {
      var drawer = document.getElementById('collection__filter__drawer');
      if (!drawer) return;
      drawer.classList.remove('open');
      setTimeout(function() { drawer.style.display = 'none'; }, 300);
    };
    window.induce_filter = function(el) {
      var domEl = el && el.jquery ? el[0] : el;
      if (domEl) domEl.classList.toggle('active');
      renderNativeCollectionDom();
    };
    window.apply_filter = function() {
      renderNativeCollectionDom();
    };
    window.clear_filter = function() {
      document.querySelectorAll('.new__filter__drawer .filter__value.active').forEach(function(el) {
        el.classList.remove('active');
      });
      renderNativeCollectionDom();
    };
    window.sort__collection = function() {
      renderNativeCollectionDom();
    };
    window.re_render_collection_page = function() {
      renderNativeCollectionDom();
    };

    // Only re-render immediately if not on default /collections/best-sellers (or still sync counts)
    if (collHandle !== 'best-sellers') {
      renderNativeCollectionDom();
    } else {
      var totalCountEl = document.getElementById('total__count');
      if (totalCountEl) totalCountEl.textContent = '41';
      document.querySelectorAll('[role="filter__count"]').forEach(function(el) {
        el.textContent = '41';
      });
      hydrateAllLooxRatings();
    }
  }

  function promoteLazyImages(root) {
    if (!root) return;
    root.querySelectorAll('img[data-src]').forEach(function(img) {
      if (img.closest('#lp-template--18750068129878__050c4273-bd7b-4abc-a9c3-9665249cc324')) return;
      var ds = img.getAttribute('data-src');
      if (ds) img.setAttribute('src', ds);
    });
    root.querySelectorAll('img[data-srcset]').forEach(function(img) {
      if (img.closest('#lp-template--18750068129878__050c4273-bd7b-4abc-a9c3-9665249cc324')) return;
      var dss = img.getAttribute('data-srcset');
      if (dss) img.setAttribute('srcset', dss);
    });
  }

  function bindStaticPageInteractions(root) {
    if (!root) return;

    // 1. FAQ Accordion (.faq-item .toggler-button & .faq-question) - start collapsed like REF
    var faqItems = root.querySelectorAll('.faq-item');
    root.querySelectorAll('.faq-item .toggler-button, .faq-question').forEach(function(triggerEl) {
      if (triggerEl.dataset.cpFaqBound) return;
      triggerEl.dataset.cpFaqBound = 'true';
      triggerEl.addEventListener('click', function() {
        var item = triggerEl.closest('.faq-item');
        if (!item) return;
        item.classList.toggle('open');
        var ans = item.querySelector('.faq-answer');
        if (ans) {
          var isHidden = getComputedStyle(ans).display === 'none';
          ans.style.display = isHidden ? 'block' : 'none';
        }
      });
    });

    // 2. FAQ Sidebar Category Navigation (.cp-faq-sidebar ul li)
    var sideLinks = root.querySelectorAll('.cp-faq-sidebar ul li');
    var answerSections = root.querySelectorAll('.answers-section');
    sideLinks.forEach(function(li, idx) {
      if (li.dataset.cpSideBound) return;
      li.dataset.cpSideBound = 'true';
      li.addEventListener('click', function() {
        sideLinks.forEach(function(s) { s.classList.remove('active'); });
        li.classList.add('active');
        var targetSec = answerSections[idx];
        if (targetSec) {
          var rect = targetSec.getBoundingClientRect();
          window.scrollTo({ top: window.scrollY + rect.top - 110, behavior: 'smooth' });
        }
      });
    });

    // 3. FAQ Live Search Input (.cp-searchbar input)
    var faqSearchInp = root.querySelector('.cp-searchbar input');
    if (faqSearchInp && !faqSearchInp.dataset.cpSearchBound) {
      faqSearchInp.dataset.cpSearchBound = 'true';
      faqSearchInp.addEventListener('input', function() {
        var q = (faqSearchInp.value || '').trim().toLowerCase();
        faqItems.forEach(function(item) {
          if (!q) {
            item.style.display = '';
            return;
          }
          var txt = (item.textContent || '').toLowerCase();
          var matched = txt.indexOf(q) !== -1;
          item.style.display = matched ? '' : 'none';
          if (matched) item.classList.add('open');
        });
      });
    }

    // 4. Swiper carousel on /pages/how-it-works & /pages/about-us (#you_might_like__new .swiper)
    if (typeof Swiper !== 'undefined') {
      root.querySelectorAll('#you_might_like__new .swiper').forEach(function(swEl) {
        if (swEl.swiper) return;
        new Swiper(swEl, {
          slidesPerView: 3,
          spaceBetween: 20,
          loop: true,
          pagination: {
            el: swEl.parentElement.querySelector('.swiper-pagination'),
            clickable: true
          },
          navigation: {
            nextEl: swEl.parentElement.querySelector('.swiper-button-next'),
            prevEl: swEl.parentElement.querySelector('.swiper-button-prev')
          },
          breakpoints: {
            1000: { slidesPerView: 4, spaceBetween: 20 },
            1350: { slidesPerView: 5, spaceBetween: 20 }
          }
        });
      });
    }

    root.querySelectorAll('.lp-faq .section-button').forEach(function(btn) {
      if (btn.dataset.cpTopBound) return;
      btn.dataset.cpTopBound = 'true';
      btn.addEventListener('click', function() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    });
  }

  function hydrateCurrentStaticPage() {
    var route = document.documentElement.getAttribute('data-cp-route');
    if (route !== 'page') return;

    var container = document.getElementById('cp-dynamic-page-container');
    if (!container || !window.CP_PAGES) return;

    var pathParts = window.location.pathname.split('/pages/');
    var pageKey = pathParts[1] ? pathParts[1].split('/')[0].split('?')[0] : 'how-it-works';
    var pageAliases = {
      'faq': 'faq-new',
      'help-faq': 'faq-new',
      'our-mission': 'our-mission-new',
      'about-us': 'our-mission-new',
      'shipping-delivery': 'shipping-and-delivery',
      'shipping-info': 'shipping-and-delivery'
    };
    var resolvedKey = pageAliases[pageKey] || pageKey;
    var pageHtml = window.CP_PAGES[pageKey] || window.CP_PAGES[resolvedKey] || window.CP_PAGES['how-it-works'] || '';

    var bodyCls = 'template-page nothomepage';
    if (pageKey === 'faq' || pageKey === 'faq-new' || resolvedKey === 'faq-new') bodyCls = 'faq template-page nothomepage';
    else if (pageKey === 'how-it-works') bodyCls = 'how-it-works-page template-page nothomepage';
    else if (pageKey === 'our-mission' || pageKey === 'our-mission-new' || pageKey === 'about-us') bodyCls = 'our-mission template-page nothomepage';
    else if (pageKey === 'reviews') bodyCls = 'loox-all-reviews template-page nothomepage';
    else if (pageKey === 'contact-us' || pageKey === 'contact') bodyCls = 'contact template-page nothomepage';
    document.body.className = bodyCls;

    var niceTitle = pageKey.replace(/-new$/i, '').replace(/-/g, ' ').replace(/\b\w/g, function(c) { return c.toUpperCase(); });
    document.title = niceTitle + ' – Crown & Paw';

    container.innerHTML = pageHtml;
    promoteLazyImages(container);
    bindStaticPageInteractions(container);
    hydrateAllLooxRatings(container);
  }

  function hydrateCurrentSearchPage() {
    var route = document.documentElement.getAttribute('data-cp-route');
    if (route !== 'search') return;

    var container = document.getElementById('cp-search-page-container');
    if (!container || !window.CP_CATALOG) return;

    var params = new URLSearchParams(window.location.search);
    var query = (params.get('q') || '').trim();
    document.title = (query ? 'Search: "' + query + '"' : 'Search') + ' – Crown & Paw';

    var allProds = Object.values(window.CP_CATALOG.productsByHandle || {});
    function doSearch(q) {
      var qLower = (q || '').trim().toLowerCase();
      var matched = qLower
        ? allProds.filter(function(p) {
            return p.title.toLowerCase().indexOf(qLower) !== -1 ||
                   (p.product_type || '').toLowerCase().indexOf(qLower) !== -1 ||
                   (p.tags || []).some(function(t) { return t.toLowerCase().indexOf(qLower) !== -1; });
          })
        : allProds.slice(0, 24);

      container.innerHTML =
        '<link href="//crownandpaw.com/cdn/shop/t/458/assets/nikita_product_card.css?v=62495771953441382441763123409" rel="stylesheet" type="text/css" media="all" />' +
        '<div style="max-width:1380px; margin:110px auto 60px; padding:0 20px;">' +
          '<div style="text-align:center; margin-bottom:36px;">' +
            '<h1 style="font:normal normal bold 36px/44px Assistant, sans-serif; color:#212121; margin-bottom:16px;">' +
              (qLower ? matched.length + ' results for "' + escapeHtml(q) + '"' : 'Search our store') +
            '</h1>' +
            '<form id="cp-search-page-form" action="/search" method="get" style="max-width:520px; margin:0 auto; display:flex; align-items:center; border-bottom:1px solid #3A3A3A;">' +
              '<input type="text" name="q" id="cp-search-page-input" value="' + escapeHtml(q) + '" placeholder="Search" style="flex:1; padding:12px 10px; border:none; background:transparent; font:normal normal normal 16px/20px Assistant, sans-serif; color:#212121; outline:none;">' +
              '<button type="submit" style="background:transparent; border:none; padding:10px; cursor:pointer;">' +
                '<svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-search" viewBox="0 0 37 40" style="width:20px; height:20px;"><path d="M35.6 36l-9.8-9.8c4.1-5.4 3.6-13.2-1.3-18.1-5.4-5.4-14.2-5.4-19.7 0-5.4 5.4-5.4 14.2 0 19.7 2.6 2.6 6.1 4.1 9.8 4.1 3 0 5.9-1 8.3-2.8l9.8 9.8c.4.4.9.6 1.4.6s1-.2 1.4-.6c.9-.9.9-2.1.1-2.9zm-20.9-8.2c-2.6 0-5.1-1-7-2.9-3.9-3.9-3.9-10.1 0-14C9.6 9 12.2 8 14.7 8s5.1 1 7 2.9c3.9 3.9 3.9 10.1 0 14-1.9 1.9-4.4 2.9-7 2.9z"/></svg>' +
              '</button>' +
            '</form>' +
          '</div>' +
          '<div class="featured_box cp-search-results-grid">' +
            matched.slice(0, 40).map(renderNikitaProductCard).join('') +
          '</div>' +
        '</div>';

      hydrateAllLooxRatings(container);

      document.getElementById('cp-search-page-form')?.addEventListener('submit', function(e) {
        e.preventDefault();
        var nextQ = document.getElementById('cp-search-page-input')?.value || '';
        window.history.replaceState({}, '', '/search?q=' + encodeURIComponent(nextQ));
        doSearch(nextQ);
      });
    }

    doSearch(query);
  }

  /* ========================================================================
     6. GLOBAL MODALS (Native <tw-gift-message-modal> + Authentic Shopify Checkout)
     ======================================================================== */
  function initGlobalModals() {
    var modalHost = document.getElementById('cp-global-modals');
    if (!modalHost) return;

    // Ensure authentic <tw-gift-message-modal> exists even on non-PDP pages
    var hasNativeGiftModal = !!document.getElementById('tw-gift-message-modal');
    var giftModalHtml = hasNativeGiftModal ? '' :
      '<link href="//crownandpaw.com/cdn/shop/t/458/assets/tw-gift-message-modal.css?v=20749371494134041131782398856" rel="stylesheet" type="text/css" media="all" />' +
      '<link href="//crownandpaw.com/cdn/shop/t/458/assets/tw-gift-message-cart.css?v=67268466701233266361782398855" rel="stylesheet" type="text/css" media="all" />' +
      '<tw-gift-message-modal id="tw-gift-message-modal" class="tw-gift-message-modal" aria-hidden="true" data-char-limit="250">' +
        '<div class="tw-gift-message-modal__overlay" data-gift-message-close></div>' +
        '<div class="tw-gift-message-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="tw-gift-message-modal-title" aria-describedby="tw-gift-message-modal-info">' +
          '<div class="tw-gift-message-modal__header">' +
            '<h2 id="tw-gift-message-modal-title" class="tw-gift-message-modal__title">Edit Gift Message</h2>' +
            '<button type="button" class="tw-gift-message-modal__close" aria-label="Close" data-gift-message-close>' +
              '<svg style="fill:none;" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">' +
                '<rect x="23.25" y="0.750001" width="22.5" height="22.5" rx="11.25" transform="rotate(90 23.25 0.750001)" stroke="#2A2A2A" stroke-width="1.5"/>' +
                '<path d="M8 8L16 16" stroke="#2A2A2A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
                '<path d="M8 16L16 8" stroke="#2A2A2A" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>' +
              '</svg>' +
            '</button>' +
          '</div>' +
          '<div class="tw-gift-message-modal__body">' +
            '<div id="tw-gift-message-modal-info" class="tw-gift-message-modal__info">Include a personal message to be printed with your order. Please note that special characters, emojis, and profanity will not be printed.</div>' +
            '<div class="tw-gift-message-modal__field">' +
              '<label class="tw-gift-message-modal__label" for="tw-gift-message-input">Edit Message</label>' +
              '<textarea id="tw-gift-message-input" class="tw-gift-message-modal__textarea" rows="5" maxlength="250" placeholder="Write your message here...." data-gift-message-input></textarea>' +
              '<span class="tw-gift-message-modal__counter" data-gift-message-counter>0 / 250</span>' +
            '</div>' +
            '<div class="tw-gift-message-modal__field tw-gift-message-modal__field--preview">' +
              '<span class="tw-gift-message-modal__label">Live Preview</span>' +
              '<div class="tw-gift-message-modal__preview-wrap">' +
                '<div class="tw-gift-message-modal__preview-card" data-gift-message-preview-card>' +
                  '<div class="tw-gift-message-modal__preview-content">' +
                    '<div class="tw-gift-message-modal__preview-message" data-gift-message-preview-text data-placeholder="Your message will appear here...">Your message will appear here...</div>' +
                  '</div>' +
                  '<div class="tw-gift-message-modal__preview-logo">' +
                    '<img src="//crownandpaw.com/cdn/shop/files/42fca67efd2c4c797907be3ebb7fc1ce41e697d6.png?v=1781056665&width=200" alt="Crown &amp; Paw" width="162" height="26" loading="lazy">' +
                  '</div>' +
                '</div>' +
              '</div>' +
              '<p class="tw-gift-message-modal__preview-caption">Message will be printed on a premium single-sided 6&quot; x 4&quot; card.</p>' +
            '</div>' +
          '</div>' +
          '<div class="tw-gift-message-modal__footer">' +
            '<button type="button" class="tw-gift-message-modal__save" data-gift-message-save disabled>SAVE MESSAGE</button>' +
          '</div>' +
        '</div>' +
      '</tw-gift-message-modal>';

    modalHost.innerHTML =
      giftModalHtml +
      '<div class="cp-modal-backdrop" id="cp-checkout-modal">' +
        '<div id="cp-checkout-modal-body" style="width:100%; height:100%;"></div>' +
      '</div>';

    // Ensure <tw-gift-message-modal> custom element is registered if tw-gift-message-modal.js wasn't loaded on this route
    if (!customElements.get('tw-gift-message-modal')) {
      var s = document.createElement('script');
      s.src = '//crownandpaw.com/cdn/shop/t/458/assets/tw-gift-message-modal.js?v=52454463614060818411782398856';
      s.defer = true;
      document.body.appendChild(s);
    }

    // Bind native .mb_container ("No photo right now? No problem!") modal on PDP
    document.querySelectorAll('.mb_close, .mb_overlay').forEach(function(el) {
      el.addEventListener('click', function() {
        var mb = document.querySelector('.mb_container');
        if (mb) mb.style.display = 'none';
      });
    });

    document.querySelectorAll('.mb_now').forEach(function(el) {
      el.addEventListener('click', function() {
        var mb = document.querySelector('.mb_container');
        if (mb) mb.style.display = 'none';
        var fileInp = document.querySelector('[data-cp-file-slot="1"]');
        if (fileInp) fileInp.click();
      });
    });

    document.querySelectorAll('.mb_later').forEach(function(el) {
      el.addEventListener('click', function() {
        var mb = document.querySelector('.mb_container');
        if (mb) mb.style.display = 'none';
        if (StepBlockInstance && StepBlockInstance.uploadWrap) {
          StepBlockInstance.uploadWrap.inputs.properties._upload_later = 'Will send photo later';
        }
        if (StepBlockInstance) {
          StepBlockInstance.setStep(3, true);
        }
      });
    });
  }

  function openShopifyCheckoutModal() {
    window.close_cart_drawer();
    var modal = document.getElementById('cp-checkout-modal');
    var body = document.getElementById('cp-checkout-modal-body');
    if (!modal || !body) return;

    var items = CPCart.getItems();
    var u = CPCart.getUpsells();
    var subCents = CPCart.getSubtotalCents();

    var itemsHtml = items.map(function(i) {
      var props = i.properties || {};
      var propLines = [];
      var petNames = [props._pet_1_petName, props._pet_2_petName, props._pet_3_petName, props._pet_4_petName, props['Pet Name']].filter(Boolean);
      if (petNames.length) propLines.push((petNames.length > 1 ? 'Pets\' Names: ' : 'Pet\'s Name: ') + escapeHtml(petNames.join(', ')));
      if (props._artist_notes) propLines.push('Artist Notes: ' + escapeHtml(props._artist_notes));
      if (props._upload_later) propLines.push('Photo: ' + escapeHtml(props._upload_later));
      if (props['_Gift Message'] || props['Gift Message']) propLines.push('Gift Message (+$5.00): ' + escapeHtml(props['_Gift Message'] || props['Gift Message']));
      if (props._Extras) propLines.push('Extras: ' + escapeHtml(props._Extras));

      var hasGift = i.hasGiftFee || (props['_Gift Message'] || props['Gift Message']);
      var gFee = hasGift ? (parseInt(i.giftFee, 10) || 500) : 0;
      var lineDisplayCents = (parseInt(i.price, 10) || 3995) * (parseInt(i.quantity, 10) || 1) + gFee;
      var optParts = [i.option1, i.option2, i.option3].filter(Boolean);

      return (
        '<div style="display:flex; align-items:center; justify-content:space-between; gap:14px; margin-bottom:16px;">' +
          '<div style="display:flex; align-items:center; gap:14px;">' +
            '<div style="position:relative; width:64px; height:64px; border:1px solid #E1E1E1; border-radius:8px; background:#fff; flex-shrink:0;">' +
              '<img src="' + escapeHtml(i.image || DEFAULT_PORTRAIT_IMG) + '" alt="' + escapeHtml(i.title) + '" style="width:100%; height:100%; object-fit:cover; border-radius:7px;">' +
              '<span style="position:absolute; top:-8px; right:-8px; background:#666666; color:#fff; font-size:12px; font-weight:600; min-width:21px; height:21px; border-radius:50%; display:flex; align-items:center; justify-content:center; padding:0 5px;">' + i.quantity + '</span>' +
            '</div>' +
            '<div>' +
              '<div style="font-size:14px; font-weight:600; color:#333333;">' + escapeHtml(i.title) + '</div>' +
              '<div style="font-size:12px; color:#737373; margin-top:2px;">' + escapeHtml(optParts.join(' / ')) + '</div>' +
              (propLines.length ? '<div style="font-size:12px; color:#737373; margin-top:2px;">' + propLines.join(' • ') + '</div>' : '') +
            '</div>' +
          '</div>' +
          '<div style="font-size:14px; font-weight:500; color:#333333;">' + formatMoney(lineDisplayCents) + '</div>' +
        '</div>'
      );
    }).join('');

    var upsellsHtml = '';
    if (items.length > 0) {
      if (u.digitalDownload) {
        upsellsHtml +=
          '<div style="display:flex; align-items:center; justify-content:space-between; gap:14px; margin-bottom:12px; font-size:13px; color:#333333;">' +
            '<span>Digital Download Add-on</span>' +
            '<span style="font-weight:500;">$10.00</span>' +
          '</div>';
      }
      if (u.skipArtwork) {
        upsellsHtml +=
          '<div style="display:flex; align-items:center; justify-content:space-between; gap:14px; margin-bottom:12px; font-size:13px; color:#333333;">' +
            '<span>Preview Your Artwork Sooner (Skip the Queue)</span>' +
            '<span style="font-weight:500;">$15.00</span>' +
          '</div>';
      }
      if (u.giftCard) {
        upsellsHtml +=
          '<div style="display:flex; align-items:center; justify-content:space-between; gap:14px; margin-bottom:12px; font-size:13px; color:#333333;">' +
            '<span>Crown &amp; Paw E-Gift Card</span>' +
            '<span style="font-weight:500;">' + formatMoney(parseInt(u.giftCardAmount, 10) || 2500) + '</span>' +
          '</div>';
      }
    }

    body.innerHTML =
      '<div class="cp-shopify-checkout">' +
        '<div class="cp-sc-main">' +
          '<div style="display:flex; align-items:center; justify-content:space-between; margin-bottom:20px;">' +
            '<a href="/" data-cp-close-modal="cp-checkout-modal">' +
              '<img src="//crownandpaw.com/cdn/shop/files/Crown-and-Paw-Black-Trademark-Logo_600x.png?v=18118581968435230010" alt="Crown &amp; Paw" style="height:34px; width:auto;">' +
            '</a>' +
            '<button type="button" data-cp-close-modal="cp-checkout-modal" style="background:transparent; border:1px solid #D9D9D9; border-radius:5px; padding:7px 14px; font-size:13px; color:#545454; cursor:pointer;">Return to store</button>' +
          '</div>' +
          '<nav style="font-size:12px; color:#737373; margin-bottom:28px;">' +
            '<a href="/cart" data-cp-close-modal="cp-checkout-modal" style="color:#1773B0; text-decoration:none;">Cart</a>' +
            ' &nbsp;&gt;&nbsp; <strong style="color:#333333;">Information</strong>' +
            ' &nbsp;&gt;&nbsp; <span>Shipping</span>' +
            ' &nbsp;&gt;&nbsp; <span>Payment</span>' +
          '</nav>' +
          '<form id="cp-shopify-checkout-form" style="display:flex; flex-direction:column; gap:20px;">' +
            '<div>' +
              '<h2 style="font-size:18px; font-weight:600; color:#333333; margin:0 0 12px;">Contact</h2>' +
              '<input type="email" class="cp-sc-input" required placeholder="Email">' +
            '</div>' +
            '<div>' +
              '<h2 style="font-size:18px; font-weight:600; color:#333333; margin:0 0 12px;">Shipping address</h2>' +
              '<div style="display:flex; flex-direction:column; gap:12px;">' +
                '<select class="cp-sc-input"><option value="US">United States</option><option value="CA">Canada</option><option value="GB">United Kingdom</option><option value="AU">Australia</option></select>' +
                '<div style="display:grid; grid-template-columns:1fr 1fr; gap:12px;">' +
                  '<input type="text" class="cp-sc-input" required placeholder="First name">' +
                  '<input type="text" class="cp-sc-input" required placeholder="Last name">' +
                '</div>' +
                '<input type="text" class="cp-sc-input" required placeholder="Address">' +
                '<input type="text" class="cp-sc-input" placeholder="Apartment, suite, etc. (optional)">' +
                '<div style="display:grid; grid-template-columns:1fr 1fr 1fr; gap:12px;">' +
                  '<input type="text" class="cp-sc-input" required placeholder="City">' +
                  '<input type="text" class="cp-sc-input" required placeholder="State">' +
                  '<input type="text" class="cp-sc-input" required placeholder="ZIP code">' +
                '</div>' +
              '</div>' +
            '</div>' +
            '<div>' +
              '<h2 style="font-size:18px; font-weight:600; color:#333333; margin:0 0 12px;">Payment</h2>' +
              '<p style="font-size:13px; color:#737373; margin:0 0 12px;">All transactions are secure and encrypted.</p>' +
              '<div style="border:1px solid #D9D9D9; border-radius:5px; overflow:hidden;">' +
                '<div style="background:#F4F8FB; padding:14px 16px; border-bottom:1px solid #D9D9D9; display:flex; justify-content:space-between; align-items:center;">' +
                  '<strong style="font-size:14px; color:#333333;">Credit card</strong>' +
                  '<span style="font-size:12px; color:#737373;">Visa • Mastercard • Amex</span>' +
                '</div>' +
                '<div style="padding:16px; background:#FAFAFA; display:flex; flex-direction:column; gap:12px;">' +
                  '<input type="text" class="cp-sc-input" placeholder="Card number" value="4242 •••• •••• 4242">' +
                  '<div style="display:grid; grid-template-columns:1fr 1fr; gap:12px;">' +
                    '<input type="text" class="cp-sc-input" placeholder="Expiration date (MM / YY)" value="12 / 28">' +
                    '<input type="text" class="cp-sc-input" placeholder="Security code" value="888">' +
                  '</div>' +
                '</div>' +
              '</div>' +
            '</div>' +
            '<button type="submit" class="cp-sc-btn-primary">Pay now</button>' +
          '</form>' +
        '</div>' +
        '<div class="cp-sc-sidebar">' +
          '<div>' + itemsHtml + upsellsHtml + '</div>' +
          '<div style="display:flex; gap:10px; padding:20px 0; border-top:1px solid #E6E6E6; border-bottom:1px solid #E6E6E6; margin:20px 0;">' +
            '<input type="text" class="cp-sc-input" placeholder="Discount code or gift card">' +
            '<button type="button" style="background:#EAEAEA; color:#545454; border:1px solid #D9D9D9; border-radius:5px; padding:0 20px; font-weight:600; cursor:pointer;">Apply</button>' +
          '</div>' +
          '<div style="display:flex; justify-content:space-between; font-size:14px; color:#545454; margin-bottom:10px;">' +
            '<span>Subtotal</span>' +
            '<span style="font-weight:500; color:#333333;">' + formatMoney(subCents) + '</span>' +
          '</div>' +
          '<div style="display:flex; justify-content:space-between; font-size:14px; color:#545454; margin-bottom:18px; padding-bottom:18px; border-bottom:1px solid #E6E6E6;">' +
            '<span>Shipping</span>' +
            '<span style="font-weight:500; color:#333333;">' + (subCents >= 7500 ? 'FREE' : '$4.95') + '</span>' +
          '</div>' +
          '<div style="display:flex; justify-content:space-between; align-items:baseline;">' +
            '<span style="font-size:16px; font-weight:600; color:#333333;">Total</span>' +
            '<div><span style="font-size:12px; color:#737373; margin-right:6px;">USD</span><strong style="font-size:21px; color:#333333;">' + formatMoney(subCents >= 7500 ? subCents : subCents + 495) + '</strong></div>' +
          '</div>' +
        '</div>' +
      '</div>';

    modal.classList.add('open');
    window.disable_scrolling();

    document.getElementById('cp-shopify-checkout-form')?.addEventListener('submit', function(e) {
      e.preventDefault();
      var orderNo = Math.floor(100000 + Math.random() * 900000);
      CPCart.clearCart();
      var mainCol = body.querySelector('.cp-sc-main');
      if (mainCol) {
        mainCol.innerHTML =
          '<div style="margin-bottom:28px;">' +
            '<img src="//crownandpaw.com/cdn/shop/files/Crown-and-Paw-Black-Trademark-Logo_600x.png?v=18118581968435230010" alt="Crown &amp; Paw" style="height:34px; width:auto;">' +
          '</div>' +
          '<div style="display:flex; align-items:center; gap:14px; margin-bottom:24px;">' +
            '<svg width="48" height="48" viewBox="0 0 48 48" fill="none" stroke="#1773B0" stroke-width="2"><circle cx="24" cy="24" r="22"/><polyline points="15 24 21 30 33 18"/></svg>' +
            '<div>' +
              '<div style="font-size:13px; color:#737373;">Confirmation #' + orderNo + '</div>' +
              '<h2 style="font-size:22px; font-weight:600; color:#333333; margin:2px 0 0;">Thank you for your purchase!</h2>' +
            '</div>' +
          '</div>' +
          '<div style="border:1px solid #D9D9D9; border-radius:5px; padding:18px; margin-bottom:24px;">' +
            '<h3 style="font-size:15px; font-weight:600; color:#333333; margin:0 0 8px;">Your order is confirmed</h3>' +
            '<p style="font-size:14px; color:#545454; line-height:1.5; margin:0;">We\'ve accepted your order, and our digital artists are getting started on your custom portrait. You will receive an email notification as soon as your artwork proof is ready to review (within 1–2 days).</p>' +
          '</div>' +
          '<button type="button" class="cp-sc-btn-primary" data-cp-close-modal="cp-checkout-modal">Continue shopping</button>';
      }
    });
  }

  /* ========================================================================
     7. INTERACTIVE SLIDERS, TABS, ACCORDIONS, COUNTDOWN & PREDICTIVE SEARCH
     ======================================================================== */
  function initSwipersAndTabs() {
    if (typeof window.Swiper === 'function' && !window.mySwiper) {
      var thumbEl = document.querySelector('.thumbsSlider_Sec');
      var mainEl = document.querySelector('.main_slider_sec');
      if (thumbEl && mainEl) {
        try {
          var thumbSwiper = new Swiper('.thumbsSlider_Sec', {
            direction: 'vertical',
            spaceBetween: 10,
            slidesPerView: 4,
            freeMode: true,
            watchSlidesProgress: true,
            navigation: {
              nextEl: '.thumbsSlider_Sec .swiper-button-next',
              prevEl: '.thumbsSlider_Sec .swiper-button-prev'
            }
          });
          window.mySwiper = new Swiper('.main_slider_sec', {
            spaceBetween: 10,
            navigation: {
              nextEl: '.swiper-2-next',
              prevEl: '.swiper-2-prev'
            },
            pagination: {
              el: '.custome_slider_pagination',
              clickable: true
            },
            thumbs: {
              swiper: thumbSwiper
            }
          });
        } catch (e) {}
      }
    }

    // Cart reservation countdown
    var cartSecs = 600;
    setInterval(function() {
      cartSecs = cartSecs <= 0 ? 600 : cartSecs - 1;
      var m = ('0' + Math.floor(cartSecs / 60)).slice(-2);
      var s = ('0' + (cartSecs % 60)).slice(-2);
      document.querySelectorAll('.slider_cart_countdown__Cart').forEach(function(el) {
        el.innerHTML = 'Your cart is reserved for <span class="Cart__Countdown">' + m + ':' + s + 's</span>';
      });
    }, 1000);

    // Normalize internal links from https://crownandpaw.com/... to /...
    document.querySelectorAll('a[href^="https://crownandpaw.com"], a[href^="http://crownandpaw.com"]').forEach(function(a) {
      var href = a.getAttribute('href');
      var rel = href.replace(/^https?:\/\/crownandpaw\.com/i, '') || '/';
      a.setAttribute('href', rel);
    });

    // Authentic Predictive Search using .predict_search_result_holder & .predictive_search__
    window.perform_search = function() {
      var inp = document.querySelector('input.search_query_inbox');
      var holder = document.querySelector('.predict_search_result_holder');
      if (!inp || !holder || !window.CP_CATALOG) return;
      var q = inp.value.trim();
      if (!q) {
        holder.style.display = 'none';
        holder.innerHTML = '';
        return;
      }
      var qLower = q.toLowerCase();
      var matches = Object.values(window.CP_CATALOG.productsByHandle || {}).filter(function(p) {
        return p.title.toLowerCase().indexOf(qLower) !== -1 || (p.product_type || '').toLowerCase().indexOf(qLower) !== -1;
      }).slice(0, 4);

      if (!matches.length) {
        holder.style.display = 'none';
        holder.innerHTML = '';
        return;
      }

      var resultsHtml = matches.map(function(p) {
        var parts = (p.title || '').split(' - ');
        var img = p.featured_image || (p.images && p.images[0]) || DEFAULT_PORTRAIT_IMG;
        return (
          '<div class="s_search_item">' +
            '<a class="s_result_lnk" href="/products/' + escapeHtml(p.handle) + '" tabindex="-1">' +
              '<div class="s_result_img_holder">' +
                '<img class="s_search_img" src="' + escapeHtml(img) + '" alt="' + escapeHtml(p.title) + '">' +
              '</div>' +
              '<div class="s_result_txt">' +
                '<span class="s_result_subheading">' + escapeHtml(parts[0] || p.title) + '</span>' +
                '<span class="s_result_txt_02">' + escapeHtml(parts[1] || p.product_type || 'Custom Pet Portrait') + '</span>' +
              '</div>' +
            '</a>' +
          '</div>'
        );
      }).join('');

      holder.innerHTML =
        '<div class="predictive_search__">' +
          '<div class="predictive_search_title">' +
            '<h3 id="predictive_search__" class="predictive_search_title__content">Results for \'' + escapeHtml(q) + '\'</h3>' +
          '</div>' +
          '<div id="predictive_search-results" class="predictive_search__list">' +
            resultsHtml +
          '</div>' +
        '</div>';
      holder.style.display = 'block';
    };

    document.querySelectorAll('input.search_query_inbox').forEach(function(inp) {
      inp.addEventListener('input', function() {
        window.perform_search();
      });
    });

    // Delegated click handlers for Cart Drawer buttons, Modals, Tabs, and Overlays
    document.addEventListener('click', function(ev) {
      var moreLooxBtn = ev.target.closest('.cp-loox-more-btn');
      if (moreLooxBtn) {
        ev.preventDefault();
        var grid = document.querySelector('#looxReviews .cp-loox-grid') || document.querySelector('.cp-loox-grid');
        if (grid) {
          var cards = Array.prototype.slice.call(grid.querySelectorAll('.cp-loox-card'));
          cards.slice(0, 8).forEach(function(c) {
            grid.appendChild(c.cloneNode(true));
          });
        }
        return;
      }

      var qtyBtn = ev.target.closest('[data-cp-cart-qty]');
      if (qtyBtn) {
        ev.preventDefault();
        ev.stopPropagation();
        var key = qtyBtn.getAttribute('data-cp-cart-key');
        var newQty = parseInt(qtyBtn.getAttribute('data-cp-cart-qty'), 10);
        CPCart.updateQuantity(key, newQty);
        return;
      }

      var giftRemoveBtn = ev.target.closest('[data-cp-gift-remove]');
      if (giftRemoveBtn) {
        ev.preventDefault();
        ev.stopPropagation();
        var lineKey = giftRemoveBtn.getAttribute('data-cp-gift-remove');
        CPCart.removeGiftMessage(lineKey);
        return;
      }

      var checkoutLink = ev.target.closest('.slider_cart_links__checkout, .vue-cart-links__checkout, [data-cp-open-checkout]');
      if (checkoutLink) {
        ev.preventDefault();
        openShopifyCheckoutModal();
        return;
      }

      var closeModalBtn = ev.target.closest('[data-cp-close-modal]');
      if (closeModalBtn) {
        ev.preventDefault();
        var modalId = closeModalBtn.getAttribute('data-cp-close-modal');
        document.getElementById(modalId)?.classList.remove('open');
        window.enable_scrolling();
        return;
      }

      var overlayOpen = ev.target.closest('.cp-product-overlay-open');
      if (overlayOpen) {
        ev.preventDefault();
        var overlayName = overlayOpen.getAttribute('data-overlay');
        var wrapper = document.querySelector('.cp-product-overlay-wrapper');
        var targetModal = overlayName ? document.querySelector('.cp-product-overlay-container.' + overlayName) : null;
        if (wrapper) wrapper.style.display = 'block';
        if (targetModal) targetModal.style.display = 'block';
        window.disable_scrolling();
        return;
      }

      var overlayClose = ev.target.closest('.cp-product-overlay-wrapper .close-btn');
      if (overlayClose || ev.target.classList.contains('cp-product-overlay-wrapper')) {
        var wrap = document.querySelector('.cp-product-overlay-wrapper');
        if (wrap) wrap.style.display = 'none';
        document.querySelectorAll('.cp-product-overlay-container').forEach(function(c) { c.style.display = 'none'; });
        window.enable_scrolling();
        return;
      }

      var pdpTab = ev.target.closest('.cp-tabbed-description .tabs-wrapper .tab');
      if (pdpTab) {
        var tabName = pdpTab.getAttribute('data-tab');
        var parent = pdpTab.closest('.cp-tabbed-description');
        if (parent && tabName) {
          parent.querySelectorAll('.tabs-wrapper .tab').forEach(function(t) { t.classList.remove('active'); });
          pdpTab.classList.add('active');
          parent.querySelectorAll('.tab-content').forEach(function(c) {
            c.style.display = c.classList.contains(tabName) ? 'block' : 'none';
          });
        }
        return;
      }
    });
  }

  /* ========================================================================
     8. BOOTSTRAP ON DOM READY
     ======================================================================== */
  function boot() {
    var activeRoute = document.documentElement.getAttribute('data-cp-route') || 'index';
    document.querySelectorAll('.cp-route-view:not(.cp-route-' + activeRoute + ')').forEach(function(el) {
      el.remove();
    });

    window.addEventListener('error', function(ev) {
      var t = ev && ev.target;
      if (t && t.tagName === 'IMG' && !t.dataset.cpFallbackApplied) {
        t.dataset.cpFallbackApplied = 'true';
        t.src = DEFAULT_PORTRAIT_IMG;
      }
    }, true);

    hydrateCurrentProductPage();
    registerCustomizerElements();
    hydrateCurrentCollectionPage();
    hydrateCurrentStaticPage();
    hydrateCurrentSearchPage();
    initGlobalModals();
    initSwipersAndTabs();
    CPCart.updateHeaderBadge();
    CPCart.renderDrawer();
    if (document.documentElement.getAttribute('data-cp-route') === 'cart') {
      CPCart.renderFullCartPage();
    }
    hydrateAllLooxRatings();
    var guardTop = document.querySelector('.cp-subpixel-guard-top');
    if (guardTop) {
      var syncSubpixelGuard = function() {
        var thr = window.innerWidth < 750 ? 7800 : 6200;
        guardTop.classList.toggle('cp-guard-active', window.scrollY > thr);
      };
      window.addEventListener('scroll', syncSubpixelGuard, { passive: true });
      window.addEventListener('resize', syncSubpixelGuard, { passive: true });
      syncSubpixelGuard();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
